export const themes = [
  
  {
    "name": "blue-light-1",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e0ecf8",
      "color-background-center": "#f5f8fd",
      "color-text": "#2d3447",

      "color-primary": "#102b6b",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#2da0d7",

      "color-secondary": "#324eb4",
      "color-on-secondary": "#ffffff",
      "color-hint": "#5a70a8",
      "color-highlight": "#677aaa",
      "color-secondary-container": "#7183ae",

      "color-bg": "#ffffff",
      "color-on-bg": "#1f3b7f",
      "color-canvas": "#dbe8f6",
      "color-divider": "#cbddee",

      "color-surface": "#e8f2fa",
      "color-on-surface": "#354469",
      "color-box-shadown": "#c5d6e7",

      "color-shimmer": "#c7ddf3",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#f80000",
      "color-selection": "#6190b5",

      "color-tab": "#102b6b",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#8da1cd"
    }
  },
  {
    "name": "ice-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e8f2f8",
      "color-background-center": "#f5f9fd",
      "color-text": "#2d3747",
  
      "color-primary": "#003d6b",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#89c3f2",
      "color-primary-container": "#00a0ff",
  
      "color-secondary": "#326ab4",
      "color-on-secondary": "#ffffff",
      "color-hint": "#5a7ea8",
      "color-highlight": "#6785aa",
      "color-secondary-container": "#718dae",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#1f5b7f",
      "color-canvas": "#d6e6f6",
      "color-divider": "#c5d5e7",
  
      "color-surface": "#e8f0fa",
      "color-on-surface": "#354469",
      "color-box-shadown": "#c5d5e7",
  
      "color-shimmer": "#c7d9f3",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#ff473d",
      "color-selection": "#90a5b5",
  
      "color-tab": "#003d6b",
      "color-tab-shadown": "#002548",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#89c3f2"
    }
  },
  
  {
    "name": "soft-blue",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f3f4f5",
      "color-background-center": "#ffffff",
      "color-text": "#1a1e21",
  
      "color-primary": "#38619c",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#CCE7FF",
      "color-primary-container": "#BED9FF",
  
      "color-secondary": "#38619c",
      "color-on-secondary": "#ffffff",
      "color-hint": "#38619c",
      "color-highlight": "#3C4055",
      "color-secondary-container": "#868998",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#5b6db7",
      "color-canvas": "#E3EAF0FF",
      "color-divider": "#dbe0e4",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#38619c",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#dbe0e4",
      "color-shimmer-light": "#ffffff",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#38619c",
      "color-tab-shadown": "#2B538A",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#D2DAFF"
    }
  },
  {
    "name": "soft-blue-redaccent",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f8fbff",
      "color-background-center": "#ffffff",
      "color-text": "#1a2c3f",
  
      "color-primary": "#c6e0f0",
      "color-on-primary": "#144870",
      "color-primary-light": "#5379a2",
      "color-primary-container": "#b84140",
  
      "color-secondary": "#da251e",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#144870",
      "color-highlight": "#054589",
      "color-secondary-container": "#6190b5",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#6190b5",
      "color-canvas": "#D3DDE9FF",
      "color-divider": "#a7c9ec",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#0a3f64",
      "color-box-shadown": "#accbec",
  
      "color-shimmer": "#f8fbff",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#0a3f64",
      "color-tab-shadown": "#152739",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#99c1e4"
    }
  },
  {
    "name": "light-blue-grey",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f3f5f8",
      "color-background-center": "#ffffff",
      "color-text": "#4b4b4b",
  
      "color-primary": "#4456a5",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#8CC9FF",
  
      "color-secondary": "#3A56A9",
      "color-on-secondary": "#ffffff",
      "color-hint": "#3A56A9",
      "color-highlight": "#4b4b4b",
      "color-secondary-container": "#99A0AD",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#4456a5",
      "color-canvas": "#E8EEF2FF",
      "color-divider": "#DEDEDE",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#3A56A9",
      "color-box-shadown": "#9F998F",
  
      "color-shimmer": "#F2F2F2",
      "color-shimmer-light": "#C8D2DC",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#4456a5",
      "color-tab-shadown": "#38488F",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#D4E4FF"
    }
  },
  {
    "name": "light-blue-dark-blue3",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f5f9fe",
      "color-background-center": "#ffffff",
      "color-text": "#202022",
  
      "color-primary": "#cfdff1",
      "color-on-primary": "#404191",
      "color-primary-light": "#7382B1",
      "color-primary-container": "#47559C",
  
      "color-secondary": "#404191",
      "color-on-secondary": "#ffffff",
      "color-hint": "#404191",
      "color-highlight": "#616F9B",
      "color-secondary-container": "#7382B1",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#47559C",
      "color-canvas": "#E9F0F7",
      "color-divider": "#b4cce5",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#404191",
      "color-box-shadown": "#83a7ce",
  
      "color-shimmer": "#ecf4fc",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#404191",
      "color-tab-shadown": "#35367E",
      "color-tab-primary": "#B3D6FF",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "light-blue-deep-blue2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f5f9fe",
      "color-background-center": "#ffffff",
      "color-text": "#202022",
  
      "color-primary": "#2948c3",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#73A6CA",
      "color-primary-container": "#73A6CA",
  
      "color-secondary": "#00355c",
      "color-on-secondary": "#ffffff",
      "color-hint": "#00355c",
      "color-highlight": "#5E8099",
      "color-secondary-container": "#5E8099",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#346384",
      "color-canvas": "#E9F0F7",
      "color-divider": "#9EB0C4",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#00355c",
      "color-box-shadown": "#83a7ce",
  
      "color-shimmer": "#DFE5EB",
      "color-shimmer-light": "#B9C4CD",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#00355c",
      "color-tab-shadown": "#002C4B",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#73A6CA"
    }
  },
  {
    "name": "light-blue-white",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#ffffff",
      "color-background-center": "#ffffff",
      "color-text": "#030E21",
  
      "color-primary": "#dee8f2",
      "color-on-primary": "#296dce",
      "color-primary-light": "#536792",
      "color-primary-container": "#edd166",
  
      "color-secondary": "#296dce",
      "color-on-secondary": "#FFFFFFFF",
      "color-hint": "#296dce",
      "color-highlight": "#576E90",
      "color-secondary-container": "#6190b5",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#BFC8DA",
      "color-canvas": "#DAEBFFFF",
      "color-divider": "#659BB1",
  
      "color-surface": "#E9EDF8",
      "color-on-surface": "#296dce",
      "color-box-shadown": "#727490FF",
  
      "color-shimmer": "#dee8f2",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#296dce",
      "color-tab-shadown": "#0A1338",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#c9ebff"
    }
  },
  {
    "name": "light-blue-black",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#FFFFFF",
      "color-background-center": "#eef4f7",
      "color-text": "#393939",
  
      "color-primary": "#013264",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#edd166",
  
      "color-secondary": "#000000",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#013264",
      "color-highlight": "#013264",
      "color-secondary-container": "#656565",
  
      "color-bg": "#eef4f7",
      "color-on-bg": "#484e51",
      "color-canvas": "#dbdbdb",
      "color-divider": "#d1d1d1",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#374b7a",
      "color-box-shadown": "#ececec",
  
      "color-shimmer": "#e0e8ee",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#013264",
      "color-tab-shadown": "#002953",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#808ba5"
    }
  },
  {
    "name": "dark-blue-black",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#FFFFFF",
      "color-background-center": "#eef4f7",
      "color-text": "#393939",
  
      "color-primary": "#0d1528",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#edd166",
  
      "color-secondary": "#000000",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#1e3262",
      "color-highlight": "#1e3262",
      "color-secondary-container": "#656565",
  
      "color-bg": "#eef4f7",
      "color-on-bg": "#484e51",
      "color-canvas": "#dbdbdb",
      "color-divider": "#d1d1d1",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#374b7a",
      "color-box-shadown": "#ececec",
  
      "color-shimmer": "#e0e8ee",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#0d1528",
      "color-tab-shadown": "#000000",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#808ba5"
    }
  },
  {
    "name": "light-blue-dark-blue",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f3f4f5",
      "color-background-center": "#ffffff",
      "color-text": "#1a1e21",
  
      "color-primary": "#1b3092",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#CCE7FF",
      "color-primary-container": "#1C3194",
  
      "color-secondary": "#1C3194",
      "color-on-secondary": "#ffffff",
      "color-hint": "#1C3194",
      "color-highlight": "#3C4055",
      "color-secondary-container": "#868998",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#5b6db7",
      "color-canvas": "#b5bfc7",
      "color-divider": "#dbe0e4",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#1C3194",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#dbe0e4",
      "color-shimmer-light": "#ffffff",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#1C3194",
      "color-tab-shadown": "#15267D",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#D2DAFF"
    }
  },
  {
    "name": "light-blue",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#deecfb",
      "color-background-center": "#ffffff",
      "color-text": "#000d37",
  
      "color-primary": "#b1cdec",
      "color-on-primary": "#060e2a",
      "color-primary-light": "#436c8b",
      "color-primary-container": "#6ca7d4",
  
      "color-secondary": "#6ca7d4",
      "color-on-secondary": "#020f2a",
      "color-hint": "#416a9a",
      "color-highlight": "#597fad",
      "color-secondary-container": "#7498c2",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#000d37",
      "color-canvas": "#E4F1FF",
      "color-divider": "#b4cce5",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#1e2e60",
      "color-box-shadown": "#83a7ce",
  
      "color-shimmer": "#a3c3e7",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#d7e7fa",
      "color-tab-primary": "#000d37",
      "color-on-tab": "#6ca7d4"
    }
  },
  {
    "name": "light-blue-dark-blue-cyan",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f5f9fe",
      "color-background-center": "#ffffff",
      "color-text": "#202022",
  
      "color-primary": "#121b45",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#36c3f3",
      "color-primary-container": "#36c3f3",
  
      "color-secondary": "#0b0c59",
      "color-on-secondary": "#ffffff",
      "color-hint": "#25266B",
      "color-highlight": "#616F9B",
      "color-secondary-container": "#5D6B98",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#47559C",
      "color-canvas": "#E9F0F7",
      "color-divider": "#b4cce5",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#0b0c59",
      "color-box-shadown": "#83a7ce",
  
      "color-shimmer": "#ecf4fc",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#0b0c59",
      "color-tab-shadown": "#2C2D6A",
      "color-tab-primary": "#36c3f3",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "light-blue-navy",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f5f9fe",
      "color-background-center": "#ffffff",
      "color-text": "#202022",
  
      "color-primary": "#121b45",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#64b190",
      "color-primary-container": "#64b190",
  
      "color-secondary": "#102254",
      "color-on-secondary": "#ffffff",
      "color-hint": "#25266B",
      "color-highlight": "#3C4D85",
      "color-secondary-container": "#5D6B98",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#47559C",
      "color-canvas": "#E9F0F7",
      "color-divider": "#b4cce5",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#102254",
      "color-box-shadown": "#83a7ce",
  
      "color-shimmer": "#ecf4fc",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#212b8f",
      "color-tab-shadown": "#0A183F",
      "color-tab-primary": "#43A279",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "light-blue-green",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f5f9fe",
      "color-background-center": "#ffffff",
      "color-text": "#202022",
  
      "color-primary": "#121b45",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#64b190",
      "color-primary-container": "#64b190",
  
      "color-secondary": "#102254",
      "color-on-secondary": "#ffffff",
      "color-hint": "#25266B",
      "color-highlight": "#3C4D85",
      "color-secondary-container": "#5D6B98",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#47559C",
      "color-canvas": "#E9F0F7",
      "color-divider": "#b4cce5",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#102254",
      "color-box-shadown": "#83a7ce",
  
      "color-shimmer": "#ecf4fc",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#43A279",
      "color-tab-shadown": "#0A183F",
      "color-tab-primary": "#212b8f",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "light-blue-green2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#dbeafa",
      "color-background-center": "#ffffff",
      "color-text": "#1a2c3f",
  
      "color-primary": "#3B9A64",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#5379a2",
      "color-primary-container": "#3B4B94",
  
      "color-secondary": "#5ea79b",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#3B4B94",
      "color-highlight": "#054589",
      "color-secondary-container": "#6190b5",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#6190b5",
      "color-canvas": "#D4DEE9FF",
      "color-divider": "#a7c9ec",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#3B4B94",
      "color-box-shadown": "#accbec",
  
      "color-shimmer": "#f8fbff",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#3B4B94",
      "color-tab-shadown": "#2E3C7D",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#A6E7C2"
    }
  },
  
  {
    "name": "light-blue-yellow2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e5ecf4",
      "color-background-center": "#ffffff",
      "color-text": "#1a1e21",
  
      "color-primary": "#002a62",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#CCE7FF",
      "color-primary-container": "#fdd600",
  
      "color-secondary": "#002a62",
      "color-on-secondary": "#ffffff",
      "color-hint": "#002a62",
      "color-highlight": "#3C4055",
      "color-secondary-container": "#53667F",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#5B81B7",
      "color-canvas": "#dbe4ee",
      "color-divider": "#dbe0e4",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#0B3A77",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#D1DEEA",
      "color-shimmer-light": "#ffffff",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#002a62",
      "color-tab-shadown": "#0D1B60",
      "color-tab-primary": "#fdd600",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "light-blue-navyaccent",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#dbeafa",
      "color-background-center": "#ffffff",
      "color-text": "#1a2c3f",
  
      "color-primary": "#c3e0ff",
      "color-on-primary": "#0f084d",
      "color-primary-light": "#5379a2",
      "color-primary-container": "#0f084d",
  
      "color-secondary": "#5970A6",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#0f084d",
      "color-highlight": "#054589",
      "color-secondary-container": "#43619D",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#6190b5",
      "color-canvas": "#DAE2EBFF",
      "color-divider": "#a7c9ec",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#0f084d",
      "color-box-shadown": "#accbec",
  
      "color-shimmer": "#f8fbff",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#0f084d",
      "color-tab-shadown": "#09043C",
      "color-tab-primary": "#fca600",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "light-blue-orange",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#dbeafa",
      "color-background-center": "#ffffff",
      "color-text": "#1a2c3f",
  
      "color-primary": "#091d75",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#98C6F7FF",
      "color-primary-container": "#0f084d",
  
      "color-secondary": "#091d75",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#091d75",
      "color-highlight": "#054589",
      "color-secondary-container": "#43619D",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#6190b5",
      "color-canvas": "#CADEF4FF",
      "color-divider": "#a7c9ec",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#091d75",
      "color-box-shadown": "#accbec",
  
      "color-shimmer": "#f8fbff",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#fc9400",
      "color-tab-shadown": "#d37c00",
      "color-tab-primary": "#091d75",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "light-blue-dark-blue-orange",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f5f9fe",
      "color-background-center": "#ffffff",
      "color-text": "#202022",
  
      "color-primary": "#121b45",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#F4751D",
      "color-primary-container": "#F4751D",
  
      "color-secondary": "#102254",
      "color-on-secondary": "#ffffff",
      "color-hint": "#25266B",
      "color-highlight": "#3C4D85",
      "color-secondary-container": "#5D6B98",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#47559C",
      "color-canvas": "#dbe4ee",
      "color-divider": "#b4cce5",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#102254",
      "color-box-shadown": "#83a7ce",
  
      "color-shimmer": "#ecf4fc",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#102254",
      "color-tab-shadown": "#0C1C47",
      "color-tab-primary": "#F4751D",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "light-blue-purple-orange",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f5f9fe",
      "color-background-center": "#ffffff",
      "color-text": "#202022",
  
      "color-primary": "#2e247a",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#C7E5FF",
      "color-primary-container": "#ea5a0e",
  
      "color-secondary": "#2e247a",
      "color-on-secondary": "#ffffff",
      "color-hint": "#25266B",
      "color-highlight": "#3C4D85",
      "color-secondary-container": "#5D6B98",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#47559C",
      "color-canvas": "#E9F0F7",
      "color-divider": "#b4cce5",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#2e247a",
      "color-box-shadown": "#83a7ce",
  
      "color-shimmer": "#ecf4fc",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#2e247a",
      "color-tab-shadown": "#261D6C",
      "color-tab-primary": "#ea5a0e",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "deep-blue-white",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#242eb4",
      "color-background-center": "#2e4ac6",
      "color-text": "#FFFFFF",
  
      "color-primary": "#16209d",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#FFFFFF",
  
      "color-secondary": "#FFFFFF",
      "color-on-secondary": "#242eb4",
      "color-hint": "#FFFFFF",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#759FD6",
  
      "color-bg": "#2e4ac6",
      "color-on-bg": "#FFFFFF",
      "color-canvas": "#252fac",
      "color-divider": "#3F49D1",
  
      "color-surface": "#4F7DDB",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#090F60",
  
      "color-shimmer": "#2e4ac6",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#FFFFFF",
      "color-tab-shadown": "#E3E4F3",
      "color-tab-primary": "#242eb4",
      "color-on-tab": "#748AD1"
    }
  },
  {
    "name": "vibrant-blue-gold",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#2542ac",
      "color-background-center": "#4c64c2",
      "color-text": "#FFFFFF",
  
      "color-primary": "#1b288a",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#edd166",
  
      "color-secondary": "#edd166",
      "color-on-secondary": "#020f2a",
      "color-hint": "#ffffff",
      "color-highlight": "#c2e1ff",
      "color-secondary-container": "#798dca",
  
      "color-bg": "#4c64c2",
      "color-on-bg": "#d8e2ff",
      "color-canvas": "#2542ac",
      "color-divider": "#2a667f",
  
      "color-surface": "#3c78dc",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#002a77",
  
      "color-shimmer": "#1352c5",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#CBD0F0",
      "color-tab-primary": "#253297",
      "color-on-tab": "#5a81d8"
    }
  },
  {
    "name": "deep-blue-bright-yellow-white8",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#072980",
      "color-background-center": "#0a4baf",
      "color-text": "#FFFFFF",
  
      "color-primary": "#141564",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffc700",
  
      "color-secondary": "#ffc700",
      "color-on-secondary": "#020f2a",
      "color-hint": "#ffffff",
      "color-highlight": "#a5c6e0",
      "color-secondary-container": "#84adcd",
  
      "color-bg": "#0a4baf",
      "color-on-bg": "#94b4e6",
      "color-canvas": "#0e41b0",
      "color-divider": "#2a4eb6",
  
      "color-surface": "#5174db",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#144d9e",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#c1d8f1",
      "color-tab-primary": "#09229e",
      "color-on-tab": "#7aa8d8"
    }
  },
  {
    "name": "deep-blue-goldcontrast",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#103259",
      "color-background-center": "#1d4068",
      "color-text": "#FFFFFF",
  
      "color-primary": "#012148",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#edd166",
  
      "color-secondary": "#edd166",
      "color-on-secondary": "#012148",
      "color-hint": "#FFFFFF",
      "color-highlight": "#b0bfe2",
      "color-secondary-container": "#7ea6c5",
  
      "color-bg": "#1d4068",
      "color-on-bg": "#78a2d2",
      "color-canvas": "#0c3463",
      "color-divider": "#1d4068",
  
      "color-surface": "#244c7c",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#244c7c",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#FFFFFF",
      "color-tab-shadown": "#9dbde1",
      "color-tab-primary": "#00235d",
      "color-on-tab": "#6b8cb3"
    }
  },
  {
    "name": "deep-blue-goldaccent",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#002259",
      "color-background-center": "#004B95",
      "color-text": "#FFFFFF",
  
      "color-primary": "#000e41",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#edd166",
  
      "color-secondary": "#edd166",
      "color-on-secondary": "#020f2a",
      "color-hint": "#ffffff",
      "color-highlight": "#c2e1ff",
      "color-secondary-container": "#798dca",
  
      "color-bg": "#004B95",
      "color-on-bg": "#d8e2ff",
      "color-canvas": "#002259",
      "color-divider": "#2a667f",
  
      "color-surface": "#004B95",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#002a77",
  
      "color-shimmer": "#003c77",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#CBD0F0",
      "color-tab-primary": "#253297",
      "color-on-tab": "#6683C2"
    }
  },
  {
    "name": "deep-blue-bright-yellow-white2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#133a71",
      "color-background-center": "#205197",
      "color-text": "#FFFFFF",
  
      "color-primary": "#0c2e60",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffc700",
  
      "color-secondary": "#ffc700",
      "color-on-secondary": "#020f2a",
      "color-hint": "#ffffff",
      "color-highlight": "#a5c6e0",
      "color-secondary-container": "#84adcd",
  
      "color-bg": "#205197",
      "color-on-bg": "#94b4e6",
      "color-canvas": "#0e41b0",
      "color-divider": "#2a4eb6",
  
      "color-surface": "#5174db",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#144d9e",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#c1d8f1",
      "color-tab-primary": "#10356b",
      "color-on-tab": "#527DAB"
    }
  },
  {
    "name": "vibrant-blue-orange",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0042c0",
      "color-background-center": "#0a52e1",
      "color-text": "#FFFFFF",
  
      "color-primary": "#000c91",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#f56d2e",
  
      "color-secondary": "#FF8E5A",
      "color-on-secondary": "#000c91",
      "color-hint": "#FF8E5A",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#83ACFF",
  
      "color-bg": "#0a52e1",
      "color-on-bg": "#cbd7ff",
      "color-canvas": "#0042c0",
      "color-divider": "#487CFF",
  
      "color-surface": "#0750e0",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#001f65",
  
      "color-shimmer": "#0a52e1",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#EEE6E2",
      "color-tab-primary": "#0027b7",
      "color-on-tab": "#DB6B37"
    }
  },
  {
    "name": "deep-blue-yellow6",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#001654",
      "color-background-center": "#212d62",
      "color-text": "#FFFFFF",
  
      "color-primary": "#001246",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffd233",
  
      "color-secondary": "#ffd233",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#9ab0de",
      "color-secondary-container": "#819ace",
  
      "color-bg": "#212d62",
      "color-on-bg": "#ffffff",
      "color-canvas": "#000c44",
      "color-divider": "#091f52",
  
      "color-surface": "#072c74",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#132662",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#00113F",
      "color-tab-shadown": "#000E34",
      "color-tab-primary": "#ffd233",
      "color-on-tab": "#8da1cd"
    }
  },
  {
    name: "blue-deep-yellow",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#020e28",
      "color-background-center": "#0e1c4d",
      "color-text": "#ffffff",

      "color-primary": "#020f2a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffd233",

      "color-secondary": "#ffd233",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#95a8d4",
      "color-secondary-container": "#819ace",

      "color-bg": "#212d62",
      "color-on-bg": "#819ace",
      "color-canvas": "#0E1F48",
      "color-divider": "#122c66",

      "color-surface": "#0C2056",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#121650",

      "color-shimmer": "#132662",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#f80000",
      "color-selection": "#6190b5",

      "color-tab": "#081E51",
      "color-tab-shadown": "#0A1336",
      "color-tab-primary": "#ffd233",
      "color-on-tab": "#8da1cd"
    }
  },
  {
    "name": "deep-blue-bright-yellow9",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#031233",
      "color-background-center": "#212d62",
      "color-text": "#FFFFFF",
  
      "color-primary": "#020f2a",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffd233",
  
      "color-secondary": "#ffd233",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#95a8d4",
      "color-secondary-container": "#819ace",
  
      "color-bg": "#212d62",
      "color-on-bg": "#819ace",
      "color-canvas": "#2a427c",
      "color-divider": "#122C66",
  
      "color-surface": "#081845",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#132662",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#051843",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#ffd233",
      "color-on-tab": "#8da1cd"
    }
  },
  {
    "name": "deep-navy-gold",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#000316",
      "color-background-center": "#212d62",
      "color-text": "#FFFFFF",
  
      "color-primary": "#020f2a",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffd233",
  
      "color-secondary": "#ffd233",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#95a8d4",
      "color-secondary-container": "#819ace",
  
      "color-bg": "#212d62",
      "color-on-bg": "#819ace",
      "color-canvas": "#2a427c",
      "color-divider": "#091f52",
  
      "color-surface": "#081845",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#030f2c",
  
      "color-shimmer": "#132662",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#051843",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#ffd233",
      "color-on-tab": "#8da1cd"
    }
  },



  {
    "name": "deep-blue-yellow4",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#131862",
      "color-background-center": "#071086",
      "color-text": "#FFFFFF",
  
      "color-primary": "#04267c",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffcf00",
  
      "color-secondary": "#ffcf00",
      "color-on-secondary": "#0f2a61",
      "color-hint": "#FEFEFF",
      "color-highlight": "#95b3da",
      "color-secondary-container": "#84a4ce",
  
      "color-bg": "#071086",
      "color-on-bg": "#FFFFFF",
      "color-canvas": "#2b4689",
      "color-divider": "#355295",
  
      "color-surface": "#3232BC",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#051f44",
  
      "color-shimmer": "#2c2d9b",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffcf00",
      "color-tab-shadown": "#FFBF00",
      "color-tab-primary": "#0f2461",
      "color-on-tab": "#674920"
    }
  },
  {
    "name": "deep-blue-yellow3",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#081e5b",
      "color-background-center": "#2a4988",
      "color-text": "#FFFFFF",
  
      "color-primary": "#001443",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#FDD32F",
  
      "color-secondary": "#FDD32F",
      "color-on-secondary": "#0f2a61",
      "color-hint": "#ffffff",
      "color-highlight": "#95b3da",
      "color-secondary-container": "#84a4ce",
  
      "color-bg": "#2a4988",
      "color-on-bg": "#97abd9",
      "color-canvas": "#2b4689",
      "color-divider": "#355295",
  
      "color-surface": "#3771bc",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#051f44",
  
      "color-shimmer": "#314d98",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#FDD32F",
      "color-tab-shadown": "#E2BB21",
      "color-tab-primary": "#002156",
      "color-on-tab": "#865F27"
    }
  },
  {
    "name": "deep-blue-amber",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0f1948",
      "color-background-center": "#2a4988",
      "color-text": "#FFFFFF",
  
      "color-primary": "#002156",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffc22b",
  
      "color-secondary": "#ffc22b",
      "color-on-secondary": "#0f2a61",
      "color-hint": "#FFFFFF",
      "color-highlight": "#AEC5E2",
      "color-secondary-container": "#84a4ce",
  
      "color-bg": "#2a4988",
      "color-on-bg": "#97abd9",
      "color-canvas": "#2b4689",
      "color-divider": "#355295",
  
      "color-surface": "#3771bc",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#051f44",
  
      "color-shimmer": "#3058a2",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#f5bb30",
      "color-tab-shadown": "#D49E20",
      "color-tab-primary": "#0f2461",
      "color-on-tab": "#4D3C25"
    }
  },
  
  
  {
    "name": "deep-blue-bright-yellow8",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#002448",
      "color-background-center": "#2a4988",
      "color-text": "#FFFFFF",
  
      "color-primary": "#00203f",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#6C8FB1",
      "color-primary-container": "#ffc22b",
  
      "color-secondary": "#ffc22b",
      "color-on-secondary": "#0f2a61",
      "color-hint": "#b0bfe2",
      "color-highlight": "#95b3da",
      "color-secondary-container": "#84a4ce",
  
      "color-bg": "#2a4988",
      "color-on-bg": "#97abd9",
      "color-canvas": "#2b4689",
      "color-divider": "#355295",
  
      "color-surface": "#052A58",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#031C3E",
  
      "color-shimmer": "#0E355C",
      "color-shimmer-light": "#668AAF",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#f5bb30",
      "color-tab-primary": "#0f2461",
      "color-on-tab": "#7d5e32",
      "color-tab-shadown": "#5e5e42"
    }
  },
  {
    "name": "deep-blue-bright-yellow7",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#1c3e96",
      "color-background-center": "#345cc2",
      "color-text": "#FFFFFF",
  
      "color-primary": "#1d2488",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#fff112",
  
      "color-secondary": "#fff112",
      "color-on-secondary": "#1d2488",
      "color-hint": "#ffffff",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#9db3e9",
  
      "color-bg": "#345cc2",
      "color-on-bg": "#bad1ff",
      "color-canvas": "#2c34ab",
      "color-divider": "#3b44c2",
  
      "color-surface": "#355ab7",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#2d54b4",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#fff112",
      "color-tab-shadown": "#DDBA0B",
      "color-tab-primary": "#272e9d",
      "color-on-tab": "#7B6A06"
    }
  },
  
  
  
  {
    "name": "deep-blue-bright-yellow",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#13519b",
      "color-background-center": "#014cb7",
      "color-text": "#FFFFFF",
  
      "color-primary": "#053983",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#fcd707",
  
      "color-secondary": "#fcd707",
      "color-hint": "#ffffff",
      "color-highlight": "#cae0ff",
      "color-secondary-container": "#a1bde6",
      "color-on-secondary": "#1d2488",
  
      "color-bg": "#014cb7",
      "color-on-bg": "#cedeff",
      "color-canvas": "#002877",
      "color-divider": "#0754c3",
  
      "color-surface": "#4796de",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-tab": "#002569",
      "color-tab-primary": "#fcd707",
      "color-tab-shadown": "#00194C",
      "color-on-tab": "#ffffff",
  
      "color-shimmer": "#124f99",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5"
    }
  },
 
  
  {
    "name": "deep-blue-yellow",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#004178",
      "color-background-center": "#212d62",
      "color-text": "#FFFFFF",
  
      "color-primary": "#00224d",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#29aae2",
      "color-primary-container": "#f5e300",
  
      "color-secondary": "#f5e300",
      "color-on-secondary": "#004178",
      "color-hint": "#ffffff",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#29aae2",
  
      "color-bg": "#00224d",
      "color-on-bg": "#416dc7",
      "color-canvas": "#00224d",
      "color-divider": "#2a667f",
  
      "color-surface": "#416dc7",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#005398",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#00224d",
      "color-tab-shadown": "#001B3E",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#29aae2"
    }
  },
  
  {
    "name": "deep-blue-orange-white",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#062753",
      "color-background-center": "#004B95",
      "color-text": "#FFFFFF",
  
      "color-primary": "#000e41",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#29aae2",
      "color-primary-container": "#ff914d",
  
      "color-secondary": "#ff914d",
      "color-on-secondary": "#062753",
      "color-hint": "#ffffff",
      "color-highlight": "#c2e1ff",
      "color-secondary-container": "#798dca",
  
      "color-bg": "#004B95",
      "color-on-bg": "#d8e2ff",
      "color-canvas": "#132b5e",
      "color-divider": "#26437d",
  
      "color-surface": "#004B95",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#001743",
  
      "color-shimmer": "#003c77",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#CBD0F0",
      "color-tab-primary": "#062753",
      "color-on-tab": "#29aae2"
    }
  },
  {
    "name": "deep-blue-orange2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#02254a",
      "color-background-center": "#212d62",
      "color-text": "#FFFFFF",
  
      "color-primary": "#011636",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffa44c",
      "color-primary-container": "#ffa44c",
  
      "color-secondary": "#ffa44c",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#6190b5",
  
      "color-bg": "#212d62",
      "color-on-bg": "#020f2a",
      "color-canvas": "#02254a",
      "color-divider": "#2a667f",
  
      "color-surface": "#416dc7",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#080C38",
  
      "color-shimmer": "#05305c",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#FFFFFF",
      "color-tab-shadown": "#E3E3E3",
      "color-tab-primary": "#0b1f61",
      "color-on-tab": "#868EB3"
    }
  },
  {
    "name": "deep-blue-orange5",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#00073c",
      "color-background-center": "#243276",
      "color-text": "#FFFFFF",
  
      "color-primary": "#010a40",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ff6600",
  
      "color-secondary": "#ff6600",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#819ace",
  
      "color-bg": "#243276",
      "color-on-bg": "#b5c2ff",
      "color-canvas": "#2a427c",
      "color-divider": "#091f52",
  
      "color-surface": "#081845",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#132662",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#000030",
      "color-tab-shadown": "#00002f",
      "color-tab-primary": "#ff6600",
      "color-on-tab": "#8da1cd"
    }
  },
  {
    "name": "deep-blue-orange4",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#263298",
      "color-background-center": "#425bc0",
      "color-text": "#FFFFFF",
  
      "color-primary": "#1b298b",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8f9ac8",
      "color-primary-container": "#ff9600",
  
      "color-secondary": "#ff9600",
      "color-on-secondary": "#1b298b",
      "color-hint": "#ffffff",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#8295dc",
  
      "color-bg": "#425bc0",
      "color-on-bg": "#dce3ff",
      "color-canvas": "#263298",
      "color-divider": "#3f59be",
  
      "color-surface": "#6279d5",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#19237c",
  
      "color-shimmer": "#1c3491",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ff7800",
      "color-tab-shadown": "#E06800",
      "color-tab-primary": "#27349a",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "deep-blue-orange3",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#042c67",
      "color-background-center": "#063976",
      "color-text": "#FFFFFF",
  
      "color-primary": "#05184a",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffa44c",
  
      "color-secondary": "#ffa44c",
      "color-on-secondary": "#020f2a",
      "color-hint": "#ffffff",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#5981B6",
  
      "color-bg": "#063976",
      "color-on-bg": "#ffffff",
      "color-canvas": "#042c67",
      "color-divider": "#0f4489",
  
      "color-surface": "#407CC6",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#02326d",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#F58C2A",
      "color-tab-shadown": "#EB8220",
      "color-tab-primary": "#0b1e60",
      "color-on-tab": "#ffffff"
    }
  },
  {
    name: "sunrise",
    colors: {
      "color-system": "#f5fbff",
      "color-background": "#00335f",
      "color-background-center": "#00508c",
      "color-text": "#fff9e6",
  
      "color-primary": "#004d8a",
      "color-on-primary": "#fff9e6",
      "color-primary-light": "#89c3f2",
      "color-primary-container": "#ff8a3e",
  
      "color-secondary": "#ff8a3e",
      "color-on-secondary": "#004d8a",
      "color-hint": "#a7d5f5",
      "color-highlight": "#ffa66a",
      "color-secondary-container": "#f1a189",
  
      "color-bg": "#3f9fcb",
      "color-on-bg": "#00335f",
      "color-canvas": "#166d7e",
      "color-divider": "#2a90ab",
  
      "color-surface": "#1e7a8b",
      "color-on-surface": "#fff9e6",
      "color-box-shadown": "#003d5a",
  
      "color-shimmer": "#3f9fcb",
      "color-shimmer-light": "#fbe3bb",
      "color-progress": "#ff3e8b",
      "color-selection": "#90b5c5",
  
      "color-tab": "#ff8a3e",
      "color-tab-shadown": "#8c5a37",
      "color-tab-primary": "#004d8a",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "deep-blue-red",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#253aa7",
      "color-background-center": "#0558bd",
      "color-text": "#FFFFFF",
  
      "color-primary": "#1c2487",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#94B5E3",
      "color-primary-container": "#d70609",
  
      "color-secondary": "#FF2D2D",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#FFFFFF",
      "color-highlight": "#FFFFFF",
      "color-secondary-container": "#AAD3FF",
  
      "color-bg": "#0558bd",
      "color-on-bg": "#E2ECFF",
      "color-canvas": "#253aa7",
      "color-divider": "#88A8DF",
  
      "color-surface": "#055FD4",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#0D1385",
  
      "color-shimmer": "#253aa7",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#d70609",
      "color-tab-shadown": "#C40407",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#FFBBBB"
    }
  },
  {
    "name": "vibrant-blue-yellow-red",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0056c8",
      "color-background-center": "#0c67e7",
      "color-text": "#FFFFFF",
  
      "color-primary": "#003e94",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#89a2c6",
      "color-primary-container": "#ffdf4a",
  
      "color-secondary": "#ffdf4a",
      "color-on-secondary": "#001a3d",
      "color-hint": "#dbeaff",
      "color-highlight": "#b8cdea",
      "color-secondary-container": "#82abe2",
  
      "color-bg": "#0c67e7",
      "color-on-bg": "#b0ddff",
      "color-canvas": "#0056c8",
      "color-divider": "#237aee",
  
      "color-surface": "#3487f4",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#003379",
  
      "color-shimmer": "#023c90",
      "color-shimmer-light": "#1e6191",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ba2300",
      "color-tab-primary": "#FFFFFF",
      "color-tab-shadown": "#9a1d00",
      "color-on-tab": "#ec9c89"
    }
  },
  {
    "name": "deep-blue-white-red",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#081b45",
      "color-background-center": "#2a4988",
      "color-text": "#FFFFFF",
  
      "color-primary": "#04267c",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffffff",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#0f2a61",
      "color-hint": "#ffffff",
      "color-highlight": "#BBCDE4",
      "color-secondary-container": "#84a4ce",
  
      "color-bg": "#2a4988",
      "color-on-bg": "#97abd9",
      "color-canvas": "#2b4689",
      "color-divider": "#355295",
  
      "color-surface": "#416dc7",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#1F3674",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#BE1D2C",
      "color-tab-shadown": "#A51625",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#FFCDD2"
    }
  },
  {
    "name": "deep-blue-orange",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#1a4381",
      "color-background-center": "#3A6AAD",
      "color-text": "#FFFFFF",
  
      "color-primary": "#092961",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#FFA600",
  
      "color-secondary": "#FFA600",
      "color-on-secondary": "#092961",
      "color-hint": "#b0bfe2",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#a5b9d5",
  
      "color-bg": "#3A6AAD",
      "color-on-bg": "#C3DCFF",
      "color-canvas": "#1a4381",
      "color-divider": "#3563A3",
  
      "color-surface": "#557fd5",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#2D5FA5",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#e00d08",
      "color-tab-shadown": "#C00502",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#FFABA8"
    }
  },
  {
    "name": "deep-blue-greenaccent",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0a3d63",
      "color-background-center": "#1b5886",
      "color-text": "#FFFFFF",
  
      "color-primary": "#063256",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#88aec9",
      "color-primary-container": "#08AA41",
  
      "color-secondary": "#08AA41",
      "color-on-secondary": "#020f2a",
      "color-hint": "#ffffff",
      "color-highlight": "#c9e8ff",
      "color-secondary-container": "#89b0ce",
  
      "color-bg": "#0a3d63",
      "color-on-bg": "#08AA41",
      "color-canvas": "#0a3d63",
      "color-divider": "#2a667f",
  
      "color-surface": "#2c6f9e",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#002241",
  
      "color-shimmer": "#13507b",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#001d37",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#08AA41",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "deep-blue-green",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#000e41",
      "color-background-center": "#003b75",
      "color-text": "#FFFFFF",
  
      "color-primary": "#020f2a",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#00c374",
  
      "color-secondary": "#00c374",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#7eafe0",
  
      "color-bg": "#003b75",
      "color-on-bg": "#6190c5",
      "color-canvas": "#2a427c",
      "color-divider": "#091f52",
  
      "color-surface": "#00326c",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#000c3a",
  
      "color-shimmer": "#132662",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#000b38",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#00c374",
      "color-on-tab": "#8da1cd"
    }
  },
  {
    "name": "deep-blue-greener",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#000e41",
      "color-background-center": "#003b75",
      "color-text": "#FFFFFF",
  
      "color-primary": "#020f2a",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#00c374",
  
      "color-secondary": "#00c374",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#7eafe0",
  
      "color-bg": "#003b75",
      "color-on-bg": "#6190c5",
      "color-canvas": "#2a427c",
      "color-divider": "#091f52",
  
      "color-surface": "#00326c",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#000c3a",
  
      "color-shimmer": "#132662",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#00c374",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#000b38",
      "color-on-tab": "#095169"
    }
  },
  {
    "name": "deep-blue-bright-lime2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0D1F9F",
      "color-background-center": "#0a4baf",
      "color-text": "#FFFFFF",
  
      "color-primary": "#141564",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#BEFF00",
  
      "color-secondary": "#BEFF00",
      "color-on-secondary": "#020f2a",
      "color-hint": "#BEFF00",
      "color-highlight": "#8EC3F8",
      "color-secondary-container": "#77B0ED",
  
      "color-bg": "#0a4baf",
      "color-on-bg": "#94b4e6",
      "color-canvas": "#061586",
      "color-divider": "#2C3DC1",
  
      "color-surface": "#3E52EA",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#1D31C9",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#BEFF00",
      "color-tab-shadown": "#A7DF00",
      "color-tab-primary": "#0D1F9F",
      "color-on-tab": "#709600"
    }
  },
  {
    "name": "deep-blue-lime",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#135188",
      "color-background-center": "#237ea7",
      "color-text": "#FFFFFF",
  
      "color-primary": "#0e4377",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#89b4c9",
      "color-primary-container": "#adca4a",
  
      "color-secondary": "#adca4a",
      "color-on-secondary": "#4a6000",
      "color-hint": "#adca4a",
      "color-highlight": "#c1eaff",
      "color-secondary-container": "#6BB0D0",
  
      "color-bg": "#237ea7",
      "color-on-bg": "#D3F1FF",
      "color-canvas": "#0f3971",
      "color-divider": "#6BB0D0",
  
      "color-surface": "#2e8bb6",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#0b2858",
  
      "color-shimmer": "#418aaf",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#adca4a",
      "color-tab-shadown": "#90AB38",
      "color-tab-primary": "#123d7f",
      "color-on-tab": "#4a6000"
    }
  },
  {
    name: "yellow_blue",
    colors: {
      "color-system": "#f5f5ff",
      "color-background": "#003d5f",
      "color-background-center": "#00688c",
      "color-text": "#ffffe6",
  
      "color-primary": "#005d8a",
      "color-on-primary": "#ffffe6",
      "color-primary-light": "#89d3f2",
      "color-primary-container": "#ffe047",
  
      "color-secondary": "#ffe047",
      "color-on-secondary": "#005d8a",
      "color-hint": "#a7e5f5",
      "color-highlight": "#ffea6a",
      "color-secondary-container": "#f1e189",
  
      "color-bg": "#3fa8cb",
      "color-on-bg": "#005d8a",
      "color-canvas": "#167e9e",
      "color-divider": "#2a90ab",
  
      "color-surface": "#1e7d8b",
      "color-on-surface": "#ffffe6",
      "color-box-shadown": "#00567a",
  
      "color-shimmer": "#00c8ff",
      "color-shimmer-light": "#bbf7fb",
      "color-progress": "#ff4785",
      "color-selection": "#90b5c5",
  
      "color-tab": "#ffe047",
      "color-tab-shadown": "#8c7a37",
      "color-tab-primary": "#005d8a",
      "color-on-tab": "#7c6d24"
    }
  },
  {
    "name": "deep-blue-cyan2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#001737",
      "color-background-center": "#212d62",
      "color-text": "#FFFFFF",
  
      "color-primary": "#00102a",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#15bfec",
  
      "color-secondary": "#15bfec",
      "color-on-secondary": "#001737",
      "color-hint": "#b0bfe2",
      "color-highlight": "#9cb0da",
      "color-secondary-container": "#819ace",
  
      "color-bg": "#212d62",
      "color-on-bg": "#15bfec",
      "color-canvas": "#2a427c",
      "color-divider": "#091f52",
  
      "color-surface": "#02244f",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#00112c",
  
      "color-shimmer": "#132662",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#00102a",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#15bfec",
      "color-on-tab": "#FFFFFF"
    }
  },
  {
    "name": "deep-ocean",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#00405C",
      "color-background-center": "#005775",
      "color-text": "#ffffff",
  
      "color-primary": "#007896",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#8fd4e2",
      "color-primary-container": "#00a3c4",
  
      "color-secondary": "#00b8d4",
      "color-on-secondary": "#002e3e",
      "color-hint": "#4dd0e1",
      "color-highlight": "#26c6da",
      "color-secondary-container": "#5ed6ea",
  
      "color-bg": "#00354d",
      "color-on-bg": "#b2ebf2",
      "color-canvas": "#002c3e",
      "color-divider": "#006a84",
  
      "color-surface": "#005067",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#001f2a",
  
      "color-shimmer": "#005c77",
      "color-shimmer-light": "#d0f1f7",
      "color-progress": "#f80000",
      "color-selection": "#80deea",
  
      "color-tab": "#00a3c4",
      "color-tab-shadown": "#004d5f",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#8fd4e2"
    }
  },
  {
    "name": "deep-blue-cyan",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#283576",
      "color-background-center": "#2a4988",
      "color-text": "#FFFFFF",
  
      "color-primary": "#04267c",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#00C7F3",
  
      "color-secondary": "#00C7F3",
      "color-hint": "#b0bfe2",
      "color-highlight": "#95b3da",
      "color-on-secondary": "#0f2a61",
      "color-secondary-container": "#7AACC6",
  
      "color-bg": "#283576",
      "color-on-bg": "#97abd9",
      "color-canvas": "#2b4689",
      "color-divider": "#355295",
  
      "color-surface": "#3771bc",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#051f44",
  
      "color-shimmer": "#314d98",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#00C7F3",
      "color-tab-primary": "#243581",
      "color-tab-shadown": "#00A5CA",
      "color-on-tab": "#005D7B"
    }
  },






  {
    "name": "deep-blue-cyan3",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#313495",
      "color-background-center": "#3955b7",
      "color-text": "#FFFFFF",
  
      "color-primary": "#2c1677",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#4158FF",
  
      "color-secondary": "#42b0fd",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#85accb",
  
      "color-bg": "#313495",
      "color-on-bg": "#e4cfff",
      "color-canvas": "#002067",
      "color-divider": "#31499c",
  
      "color-surface": "#5772d0",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#1a2672",
  
      "color-shimmer": "#4661c3",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#4158FF",
      "color-tab-shadown": "#2438D4",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#bcc4ff"
    }
  },
  {
    "name": "aqua-sky",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e0f7fa",
      "color-background-center": "#b2ebf2",
      "color-text": "#004d40",
  
      "color-primary": "#00acc1",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#4dd0e1",
      "color-primary-container": "#26c6da",
  
      "color-secondary": "#4db6ac",
      "color-on-secondary": "#004d40",
      "color-hint": "#b2dfdb",
      "color-highlight": "#80cbc4",
      "color-secondary-container": "#26a69a",
  
      "color-bg": "#e0f2f1",
      "color-on-bg": "#00695c",
      "color-canvas": "#b2dfdb",
      "color-divider": "#80cbc4",
  
      "color-surface": "#e0f7fa",
      "color-on-surface": "#004d40",
      "color-box-shadown": "#80deea",
  
      "color-shimmer": "#b2ebf2",
      "color-shimmer-light": "#e0f7fa",
      "color-progress": "#f80000",
      "color-selection": "#4dd0e1",
  
      "color-tab": "#00acc1",
      "color-tab-shadown": "#007c91",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#005762"
    }
  },
  {
    "name": "blue-white-dark",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#4c628a",
      "color-background-center": "#a9bed8",
      "color-text": "#FFFFFF",
  
      "color-primary": "#6c8cc8",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#323D54",
      "color-primary-container": "#263450",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#263450",
      "color-hint": "#FFFFFF",
      "color-highlight": "#DCEAFE",
      "color-secondary-container": "#CCDFED",
  
      "color-bg": "#a9bed8",
      "color-on-bg": "#263450",
      "color-canvas": "#4c628a",
      "color-divider": "#739DBA",
  
      "color-surface": "#8BA8CC",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#212c41",
  
      "color-shimmer": "#98b0ce",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#6c8cc8",
      "color-tab-shadown": "#5876AF",
      "color-tab-primary": "#263450",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "azul-sereno-e-coral",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#c6d8ea",
      "color-background-center": "#ffffff",
      "color-text": "#212121",
  
      "color-primary": "#2196f3",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#64b5f6",
      "color-primary-container": "#90caf9",
  
      "color-secondary": "#dd3500",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#dd3500",
      "color-highlight": "#80a5cf",
      "color-secondary-container": "#87a3bf",
  
      "color-bg": "#9cc3e3",
      "color-on-bg": "#075a9c",
      "color-canvas": "#c6d8ea",
      "color-divider": "#1976d2",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#212121",
      "color-box-shadown": "#1976d2",
  
      "color-shimmer": "#c6d8ea",
      "color-shimmer-light": "#e1f5fe",
      "color-progress": "#1976d2",
      "color-selection": "#1976d2",
  
      "color-tab": "#2196f3",
      "color-tab-shadown": "#0d47a1",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#075a9c"
    }
  },
  {
    "name": "light-blue-dark-blue-yellow",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e5ecf4",
      "color-background-center": "#ffffff",
      "color-text": "#353a59",
  
      "color-primary": "#353a59",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#89A4CE",
      "color-primary-container": "#fdd600",
  
      "color-secondary": "#353a59",
      "color-on-secondary": "#ffffff",
      "color-hint": "#0353a59",
      "color-highlight": "#3C4055",
      "color-secondary-container": "#73869F",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#5B81B7",
      "color-canvas": "#b5bfc7",
      "color-divider": "#dbe0e4",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#353a59",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#D1DEEA",
      "color-shimmer-light": "#ffffff",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#353a59",
      "color-tab-shadown": "#272B44",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#89A4CE"
    }
  },
  {
    "name": "cinza-industrial-e-ciano",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#b0bec5",
      "color-background-center": "#e0e0e0",
      "color-text": "#212121",
  
      "color-primary": "#233037",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#90a4ae",
      "color-primary-container": "#b0bec5",
  
      "color-secondary": "#00acc1",
      "color-on-secondary": "#212121",
      "color-hint": "#3f545e",
      "color-highlight": "#6a828d",
      "color-secondary-container": "#6a828d",
  
      "color-bg": "#b0bec5",
      "color-on-bg": "#607d8b",
      "color-canvas": "#e0e0e0",
      "color-divider": "#455a64",
  
      "color-surface": "#f5f5f5",
      "color-on-surface": "#212121",
      "color-box-shadown": "#455a64",
  
      "color-shimmer": "#b0bec5",
      "color-shimmer-light": "#e0f2f1",
      "color-progress": "#00838f",
      "color-selection": "#00838f",
  
      "color-tab": "#607d8b",
      "color-tab-shadown": "#263238",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#233037"
    }
  },
  {
    "name": "deep-lake",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#264654",
      "color-background-center": "#3a5f6d",
      "color-text": "#ffffff",
  
      "color-primary": "#3b7384",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#a4c7d1",
      "color-primary-container": "#4c8b9e",
  
      "color-secondary": "#6fb3c5",
      "color-on-secondary": "#1c2e36",
      "color-hint": "#bfdde6",
      "color-highlight": "#9acfdc",
      "color-secondary-container": "#7eb9c9",
  
      "color-bg": "#1e3945",
      "color-on-bg": "#ffffff",
      "color-canvas": "#1b323d",
      "color-divider": "#456c79",
  
      "color-surface": "#355c69",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#132931",
  
      "color-shimmer": "#46717f",
      "color-shimmer-light": "#e1f5fe",
      "color-progress": "#f80000",
      "color-selection": "#80deea",
  
      "color-tab": "#4c8b9e",
      "color-tab-shadown": "#2d4f5d",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#a4c7d1"
    }
  },
  {
    "name": "mist-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f0eef5",
      "color-background-center": "#faf9fd",
      "color-text": "#3d3842",
  
      "color-primary": "#5d5a8a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#c3c1f2",
      "color-primary-container": "#8a85ff",
  
      "color-secondary": "#6a67b4",
      "color-on-secondary": "#ffffff",
      "color-hint": "#8585a8",
      "color-highlight": "#9292aa",
      "color-secondary-container": "#9e9eae",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#3d3d7f",
      "color-canvas": "#e4e4f6",
      "color-divider": "#d4d4e9",
  
      "color-surface": "#efeffa",
      "color-on-surface": "#444469",
      "color-box-shadown": "#cfcfe7",
  
      "color-shimmer": "#ddc7f3",
      "color-shimmer-light": "#d5c5fb",
      "color-progress": "#ffa347",
      "color-selection": "#a9a9b5",
  
      "color-tab": "#5d5a8a",
      "color-tab-shadown": "#323248",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#c3c1f2"
    }
  },
  {
    "name": "blush-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f8e8ec",
      "color-background-center": "#fdf5f7",
      "color-text": "#473438",
  
      "color-primary": "#8a2a4e",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#f2a8c3",
      "color-primary-container": "#d74d85",
  
      "color-secondary": "#b4326a",
      "color-on-secondary": "#ffffff",
      "color-hint": "#a85a7a",
      "color-highlight": "#aa6782",
      "color-secondary-container": "#ae7189",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#7f1f4a",
      "color-canvas": "#f6d6e0",
      "color-divider": "#eec5d4",
  
      "color-surface": "#fae8ef",
      "color-on-surface": "#694454",
      "color-box-shadown": "#e7c5d2",
  
      "color-shimmer": "#f3c7d9",
      "color-shimmer-light": "#fbbbd7",
      "color-progress": "#00a38a",
      "color-selection": "#b5909e",
  
      "color-tab": "#8a2a4e",
      "color-tab-shadown": "#48182b",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#f2a8c3"
    }
  },
  {
    "name": "orchid-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f8eef5",
      "color-background-center": "#fdf7fb",
      "color-text": "#3d3447",
  
      "color-primary": "#7a2d8a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#e3a8f2",
      "color-primary-container": "#c547e8",
  
      "color-secondary": "#9a32b4",
      "color-on-secondary": "#ffffff",
      "color-hint": "#a85a8a",
      "color-highlight": "#aa6792",
      "color-secondary-container": "#ae7199",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#5d1f7f",
      "color-canvas": "#f0d6f6",
      "color-divider": "#e0c5e9",
  
      "color-surface": "#f5e8fa",
      "color-on-surface": "#4a3469",
      "color-box-shadown": "#d7c5e7",
  
      "color-shimmer": "#efc7f3",
      "color-shimmer-light": "#f5bbfb",
      "color-progress": "#47d1ff",
      "color-selection": "#b590b0",
  
      "color-tab": "#7a2d8a",
      "color-tab-shadown": "#481858",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#e3a8f2"
    }
  },
  {
    "name": "lilac-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f3eef8",
      "color-background-center": "#faf7fd",
      "color-text": "#3d3847",
  
      "color-primary": "#5d3d8a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#d1b8f2",
      "color-primary-container": "#a47dff",
  
      "color-secondary": "#7a5fcb",
      "color-on-secondary": "#ffffff",
      "color-hint": "#8d85a8",
      "color-highlight": "#9a94aa",
      "color-secondary-container": "#a59eae",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#4d2b7f",
      "color-canvas": "#eae4f6",
      "color-divider": "#d9d4ee",
  
      "color-surface": "#f2effa",
      "color-on-surface": "#4a4469",
      "color-box-shadown": "#d5cfe7",
  
      "color-shimmer": "#e3ddf3",
      "color-shimmer-light": "#d5c5fb",
      "color-progress": "#ff8a47",
      "color-selection": "#b5a9d5",
  
      "color-tab": "#5d3d8a",
      "color-tab-shadown": "#322548",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#d1b8f2"
    }
  },
  {
    "name": "lavender-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f0eef8",
      "color-background-center": "#faf9fd",
      "color-text": "#3d3847",
  
      "color-primary": "#4e3d8a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#c3b8f2",
      "color-primary-container": "#8a6dff",
  
      "color-secondary": "#6a5fcb",
      "color-on-secondary": "#ffffff",
      "color-hint": "#8d85a8",
      "color-highlight": "#9a94aa",
      "color-secondary-container": "#a59eae",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#3d2b7f",
      "color-canvas": "#e8e4f6",
      "color-divider": "#d9d4ee",
  
      "color-surface": "#f2effa",
      "color-on-surface": "#4a4469",
      "color-box-shadown": "#d5cfe7",
  
      "color-shimmer": "#e3ddf3",
      "color-shimmer-light": "#e0d5fb",
      "color-progress": "#ff47a3",
      "color-selection": "#b5a9d5",
  
      "color-tab": "#4e3d8a",
      "color-tab-shadown": "#322548",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#c3b8f2"
    }
  },
  {
    "name": "light-blue-magenta",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e5f1ff",
      "color-background-center": "#ffffff",
      "color-text": "#1a2c3f",
  
      "color-primary": "#e9f4ff",
      "color-on-primary": "#b00389",
      "color-primary-light": "#5379a2",
      "color-primary-container": "#8a136f",
  
      "color-secondary": "#b00389",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#b00389",
      "color-highlight": "#054589",
      "color-secondary-container": "#6190b5",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#6190b5",
      "color-canvas": "#e5f1ff",
      "color-divider": "#a7c9ec",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#375b83",
      "color-box-shadown": "#76abe3",
  
      "color-shimmer": "#daedff",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#8a136f",
      "color-tab-shadown": "#6c0855",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#ffcbf3"
    }
  },
  
  {
    "name": "pastel-rose",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#fce4ec",
      "color-background-center": "#fff0f5",
      "color-text": "#4a2c3a",
  
      "color-primary": "#ec407a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#f8bbd0",
      "color-primary-container": "#f06292",
  
      "color-secondary": "#ba68c8",
      "color-on-secondary": "#4a2c3a",
      "color-hint": "#ba68c8",
      "color-highlight": "#d891e4",
      "color-secondary-container": "#d891e4",
  
      "color-bg": "#fce4ec",
      "color-on-bg": "#6a1b47",
      "color-canvas": "#fce4ec",
      "color-divider": "#e1bee7",
  
      "color-surface": "#f3e5f5",
      "color-on-surface": "#4a2c3a",
      "color-box-shadown": "#b48cae",
  
      "color-shimmer": "#f8bbd0",
      "color-shimmer-light": "#ffeef8",
      "color-progress": "#f80000",
      "color-selection": "#f48fb1",
  
      "color-tab": "#ec407a",
      "color-tab-shadown": "#b35a8e",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#f8bbd0"
    }
  },
  {
    "name": "roxo-ametista-e-dourado",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e1bee7",
      "color-background-center": "#f3e5f5",
      "color-text": "#212121",
  
      "color-primary": "#9c27b0",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ba68c8",
      "color-primary-container": "#ce93d8",
  
      "color-secondary": "#9c27b0",
      "color-on-secondary": "#212121",
      "color-hint": "#9c27b0",
      "color-highlight": "#b45ac3",
      "color-secondary-container": "#b45ac3",
  
      "color-bg": "#e1bee7",
      "color-on-bg": "#9c27b0",
      "color-canvas": "#e1bee7",
      "color-divider": "#7b1fa2",
  
      "color-surface": "#f9fbe7",
      "color-on-surface": "#212121",
      "color-box-shadown": "#7b1fa2",
  
      "color-shimmer": "#e040fb",
      "color-shimmer-light": "#f3e5f5",
      "color-progress": "#7b1fa2",
      "color-selection": "#7b1fa2",
  
      "color-tab": "#9c27b0",
      "color-tab-shadown": "#4a148c",
      "color-tab-primary": "#ffb300",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "warm-red-purple-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#c25c64",
      "color-background-center": "#e58e95",
      "color-text": "#FFFFFF",
  
      "color-primary": "#54216b",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffffff",
      "color-primary-container": "#FFFE6C0",
  
      "color-secondary": "#FFFFFF",
      "color-on-secondary": "#595AF2",
      "color-hint": "#ffffff",
      "color-highlight": "#ffffff",
      "color-secondary-container": "#ffffff",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#b65760",
      "color-canvas": "#c25c64",
      "color-divider": "#ffffff",
  
      "color-surface": "#FF8D58",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#a42e47",
  
      "color-shimmer": "#D9835C",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#D6D4E2",
      "color-tab-primary": "#5E279E",
      "color-on-tab": "#8C8CBE"
    }
  },
  {
    "name": "deep-purple-light-blue2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#3d137a",
      "color-background-center": "#212d62",
      "color-text": "#FFFFFF",
  
      "color-primary": "#8d31c8",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#eaa0ff",
      "color-primary-container": "#edd166",
  
      "color-secondary": "#85bbf6",
      "color-on-secondary": "#020f2a",
      "color-hint": "#b0bfe2",
      "color-highlight": "#beaee4",
      "color-secondary-container": "#ac9bd7",
  
      "color-bg": "#2f3d79",
      "color-on-bg": "#ac9bd7",
      "color-canvas": "#1c2758",
      "color-divider": "#5f3b93",
  
      "color-surface": "#416dc7",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#543aaa",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#5112cd",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#ae85ff"
    }
  },
  {
    name: "neon",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#1a003d",
      "color-background-center": "#2e0068",
      "color-text": "#ffffff",
  
      "color-primary": "#23005d",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#c289f2",
      "color-primary-container": "#00f0ff",
  
      "color-secondary": "#00f0ff",
      "color-on-secondary": "#23005d",
      "color-hint": "#d1a7f5",
      "color-highlight": "#00e0ff",
      "color-secondary-container": "#89e1f1",
  
      "color-bg": "#6a3fcb",
      "color-on-bg": "#00e0ff",
      "color-canvas": "#3d167e",
      "color-divider": "#8a2aab",
  
      "color-surface": "#4b1e8b",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#1a0056",
  
      "color-shimmer": "#3d00ff",
      "color-shimmer-light": "#bbfbfb",
      "color-progress": "#ff00f8",
      "color-selection": "#90b5b5",
  
      "color-tab": "#00f0ff",
      "color-tab-shadown": "#8c37a1",
      "color-tab-primary": "#23005d",
      "color-on-tab": "#8c37a1"
    }
  },
  {
    name: "amethyst",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#1e003d",
      "color-background-center": "#3d007a",
      "color-text": "#f0e6ff",
  
      "color-primary": "#2a005d",
      "color-on-primary": "#ffecfd",
      "color-primary-light": "#e289f2",
      "color-primary-container": "#ff4dd8",
  
      "color-secondary": "#ff4dd8",
      "color-on-secondary": "#2a005d",
      "color-hint": "#f5a7eb",
      "color-highlight": "#ff6aed",
      "color-secondary-container": "#f189e1",
  
      "color-bg": "#8c3fcb",
      "color-on-bg": "#ffecfd",
      "color-canvas": "#4d167e",
      "color-divider": "#a02aab",
  
      "color-surface": "#5c1e8b",
      "color-on-surface": "#ffecfd",
      "color-box-shadown": "#2a0056",
  
      "color-shimmer": "#8d00ff",
      "color-shimmer-light": "#fbbbfb",
      "color-progress": "#4dfcff",
      "color-selection": "#c590b5",
  
      "color-tab": "#ff4dd8",
      "color-tab-shadown": "#8c37a1",
      "color-tab-primary": "#2a005d",
      "color-on-tab": "#ffffff"
    }
  },
  {
    name: "vintage",
    colors: {
      "color-system": "#fffaf0",
      "color-background": "#1a0f3d",
      "color-background-center": "#2e1d68",
      "color-text": "#fff5e6",
  
      "color-primary": "#2a155d",
      "color-on-primary": "#fff5e6",
      "color-primary-light": "#c3a8f2",
      "color-primary-container": "#ffb347",
  
      "color-secondary": "#ffb347",
      "color-on-secondary": "#2a155d",
      "color-hint": "#d7c7f5",
      "color-highlight": "#ffca6a",
      "color-secondary-container": "#e1c189",
  
      "color-bg": "#4a3fcb",
      "color-on-bg": "#fff5e6",
      "color-canvas": "#2d167e",
      "color-divider": "#5c2aab",
  
      "color-surface": "#3c1e8b",
      "color-on-surface": "#fff5e6",
      "color-box-shadown": "#1a0556",
  
      "color-shimmer": "#5d3dff",
      "color-shimmer-light": "#fbf0bb",
      "color-progress": "#47ff8b",
      "color-selection": "#b5a361",
  
      "color-tab": "#ffb347",
      "color-tab-shadown": "#8c6a37",
      "color-tab-primary": "#2a155d",
      "color-on-tab": "#ffffff"
    }
  },
  {
    name: "deep-purple-yellow",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#3d005f",
      "color-background-center": "#691890",
      "color-text": "#ffffff",

      "color-primary": "#3e005d",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#c289f2",
      "color-primary-container": "#feae00",

      "color-secondary": "#feae00",
      "color-on-secondary": "#3e005d",
      "color-hint": "#d1a7f5",
      "color-highlight": "#c492ef",
      "color-secondary-container": "#c189f1",

      "color-bg": "#8c3fcb",
      "color-on-bg": "#3e005d",
      "color-canvas": "#51167e",
      "color-divider": "#6f2aab",

      "color-surface": "#5c1e8b",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#390056",

      "color-shimmer": "#3d005d",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#f80000",
      "color-selection": "#6190b5",

      "color-tab": "#feae00",
      "color-tab-shadown": "#8c4737",
      "color-tab-primary": "#3e005d",
      "color-on-tab": "#8c4737"
    }
  },
  {
    "name": "deep-purple-gold",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#320150",
      "color-background-center": "#4c0a74",
      "color-text": "#FFFFFF",
  
      "color-primary": "#27013d",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#c289f2",
      "color-primary-container": "#ffcc06",
  
      "color-secondary": "#ffcc06",
      "color-on-secondary": "#27013d",
      "color-hint": "#FFFFFF",
      "color-highlight": "#E1BEFF",
      "color-secondary-container": "#c189f1",
  
      "color-bg": "#5d138a",
      "color-on-bg": "#EBCBFF",
      "color-canvas": "#51167e",
      "color-divider": "#6f2aab",
  
      "color-surface": "#6E1B9E",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#2E0045",
  
      "color-shimmer": "#3d005d",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffcc06",
      "color-tab-shadown": "#FFA406",
      "color-tab-primary": "#3e005d",
      "color-on-tab": "#8c4737"
    }
  },
  {
    "name": "deep-purple-gold2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#3d137a",
      "color-background-center": "#41127f",
      "color-text": "#FFFFFF",
  
      "color-primary": "#371170",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#eaa0ff",
      "color-primary-container": "#edd166",
  
      "color-secondary": "#ffbf0f",
      "color-on-secondary": "#2c0764",
      "color-hint": "#ffbf0f",
      "color-highlight": "#beaee4",
      "color-secondary-container": "#ac9bd7",
  
      "color-bg": "#5d138a",
      "color-on-bg": "#e4cfff",
      "color-canvas": "#340d6c",
      "color-divider": "#5f3b93",
  
      "color-surface": "#416dc7",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#543aaa",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffbf0f",
      "color-tab-shadown": "#b7890a",
      "color-tab-primary": "#672b23",
      "color-on-tab": "#bb7b00"
    }
  },
  {
    name: "yellow_purple",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#3d005f",
      "color-background-center": "#5a008c",
      "color-text": "#fffae6",
  
      "color-primary": "#5d008a",
      "color-on-primary": "#fffae6",
      "color-primary-light": "#d389f2",
      "color-primary-container": "#ffd700",
  
      "color-secondary": "#ffd700",
      "color-on-secondary": "#5d008a",
      "color-hint": "#e5a7f5",
      "color-highlight": "#ffea6a",
      "color-secondary-container": "#f1e189",
  
      "color-bg": "#8c3fcb",
      "color-on-bg": "#5d008a",
      "color-canvas": "#6a167e",
      "color-divider": "#a02aab",
  
      "color-surface": "#7d1e8b",
      "color-on-surface": "#fffae6",
      "color-box-shadown": "#3a0056",
  
      "color-shimmer": "#6a167e",
      "color-shimmer-light": "#fbfbbb",
      "color-progress": "#00ffd7",
      "color-selection": "#b590b5",
  
      "color-tab": "#ffd700",
      "color-tab-shadown": "#8c6a37",
      "color-tab-primary": "#5d008a",
      "color-on-tab": "#a47000"
    }
  },
  {
    "name": "deep-purple-bright-yellow",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#3a3783",
      "color-background-center": "#5350a4",
      "color-text": "#FFFFFF",
  
      "color-primary": "#322f79",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#FFC600",
  
      "color-secondary": "#FFC600",
      "color-on-secondary": "#020f2a",
      "color-hint": "#FFC600",
      "color-highlight": "#c9dfff",
      "color-secondary-container": "#afade4",
  
      "color-bg": "#5350a4",
      "color-on-bg": "#d9d8ff",
      "color-canvas": "#3a3783",
      "color-divider": "#35327d",
  
      "color-surface": "#8E8CCD",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#4b4897",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#FFC600",
      "color-tab-shadown": "#E4B300",
      "color-tab-primary": "#3a3783",
      "color-on-tab": "#694312"
    }
  },
  {
    "name": "deep-purple-sunset",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#444698",
      "color-background-center": "#5c5eb2",
      "color-text": "#FFFFFF",
  
      "color-primary": "#2a2c74",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#bfc0ed",
      "color-primary-container": "#FF8A30",
  
      "color-secondary": "#FF8D30",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#FFFFFF",
      "color-highlight": "#A6A7D2",
      "color-secondary-container": "#bfc0ed",
  
      "color-bg": "#212d62",
      "color-on-bg": "#CECFFF",
      "color-canvas": "#444698",
      "color-divider": "#5658ac",
  
      "color-surface": "#7776C3",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#8827286b",
  
      "color-shimmer": "#7172C2",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#FF8A30",
      "color-tab-shadown": "#C35B1F",
      "color-tab-primary": "#2c2e77",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "deep-amethyst-fire",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#4a2264",
      "color-background-center": "#71399f",
      "color-text": "#FFFFFF",
  
      "color-primary": "#40084b",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#b190cd",
      "color-primary-container": "#e9632d",
  
      "color-secondary": "#e9632d",
      "color-on-secondary": "#4a2264",
      "color-hint": "#FFFFFF",
      "color-highlight": "#EED8FF",
      "color-secondary-container": "#be93df",
  
      "color-bg": "#7941a7",
      "color-on-bg": "#F2E3FF",
      "color-canvas": "#4a2264",
      "color-divider": "#9c63c8",
  
      "color-surface": "#8851b5",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#370f46",
  
      "color-shimmer": "#8851b5",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#FF6222",
      "color-tab-shadown": "#D9480F",
      "color-tab-primary": "#4a2264",
      "color-on-tab": "#ffffff"
    }
  },
  {
    name: "purple-glow",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#9b59b6",
      "color-background-center": "#8e44ad",
      "color-text": "#ffffff",
  
      "color-primary": "#6a1b9a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#9c4dcc",
      "color-primary-container": "#ba68c8",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#6a1b9a",
      "color-hint": "#ffffff",
      "color-highlight": "#c99ddb",
      "color-secondary-container": "#f48fb1",
  
      "color-bg": "#a35cc1",
      "color-on-bg": "#8d173f",
      "color-canvas": "#8e24aa",
      "color-divider": "#7b1fa2",
  
      "color-surface": "#6a1b9a",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#4a148c",
  
      "color-shimmer": "#6a1b9a",
      "color-shimmer-light": "#f3e5f5",
      "color-progress": "#f80000",
      "color-selection": "#ba68c8",
  
      "color-tab": "#ec407a",
      "color-tab-shadown": "#d81b60",
      "color-tab-primary": "#6a1b9a",
      "color-on-tab": "#8d173f"
    }
  },
  {
    name: "lavender",
    colors: {
      "color-system": "#f8f9ff",
      "color-background": "#3d2a5f",
      "color-background-center": "#5a3d8c",
      "color-text": "#f0f7f4",
  
      "color-primary": "#4b3d6d",
      "color-on-primary": "#f0f7f4",
      "color-primary-light": "#d1c3f2",
      "color-primary-container": "#a2f0d0",
  
      "color-secondary": "#a2f0d0",
      "color-on-secondary": "#3d2a5f",
      "color-hint": "#e3d5f5",
      "color-highlight": "#c9f2e2",
      "color-secondary-container": "#b8e1f1",
  
      "color-bg": "#7d6fcb",
      "color-on-bg": "#f0f7f4",
      "color-canvas": "#4d3e7e",
      "color-divider": "#8a7aab",
  
      "color-surface": "#6a5c8b",
      "color-on-surface": "#f0f7f4",
      "color-box-shadown": "#3a2a56",
  
      "color-shimmer": "#7d6fff",
      "color-shimmer-light": "#d5fbfb",
      "color-progress": "#ff6b8b",
      "color-selection": "#a5b5d5",
  
      "color-tab": "#a2f0d0",
      "color-tab-shadown": "#6d8c7a",
      "color-tab-primary": "#4b3d6d",
      "color-on-tab": "#3c7f64"
    }
  },
  {
    "name": "retro-fusion",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#9C1F63",
      "color-background-center": "#b43879",
      "color-text": "#ffffff",
  
      "color-primary": "#00A39B",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#8de2dd",
      "color-primary-container": "#1dbbb2",
  
      "color-secondary": "#F7EF10",
      "color-on-secondary": "#3a3a00",
      "color-hint": "#fffcb1",
      "color-highlight": "#f9f06b",
      "color-secondary-container": "#f3eb57",
  
      "color-bg": "#871a55",
      "color-on-bg": "#ffffff",
      "color-canvas": "#6e1445",
      "color-divider": "#d34c97",
  
      "color-surface": "#b94887",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#5a0e36",
  
      "color-shimmer": "#c45299",
      "color-shimmer-light": "#fad1e8",
      "color-progress": "#F7EF10",
      "color-selection": "#f9f06b",
  
      "color-tab": "#00A39B",
      "color-tab-shadown": "#005a55",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#b6ebe9"
    }
  },
  {
    "name": "purple-night",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#59518D",
      "color-background-center": "#6c66a0",
      "color-text": "#ffffff",
  
      "color-primary": "#7f76c5",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#c5bff0",
      "color-primary-container": "#9d94db",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#392f6e",
      "color-hint": "#f1e9ff",
      "color-highlight": "#b39ddb",
      "color-secondary-container": "#d9cdef",
  
      "color-bg": "#483f77",
      "color-on-bg": "#ece8f6",
      "color-canvas": "#403a66",
      "color-divider": "#6e65aa",
  
      "color-surface": "#6a63a2",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#2c264a",
  
      "color-shimmer": "#7e77b5",
      "color-shimmer-light": "#e0e0f6",
      "color-progress": "#f80000",
      "color-selection": "#bdaaf2",
  
      "color-tab": "#9d94db",
      "color-tab-shadown": "#554e8a",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#4a4089"
    }
  },
  {
    "name": "velvet-sunset",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#49426E",
      "color-background-center": "#5b5483",
      "color-text": "#ffffff",
  
      "color-primary": "#322E53",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#f3d7b2",
      "color-primary-container": "#d6a06a",
  
      "color-secondary": "#EBC18F",
      "color-on-secondary": "#49426E",
      "color-hint": "#c5bbdb",
      "color-highlight": "#d8c9ea",
      "color-secondary-container": "#a89ec4",
  
      "color-bg": "#3f3860",
      "color-on-bg": "#ffffff",
      "color-canvas": "#362f56",
      "color-divider": "#6e6893",
  
      "color-surface": "#7b73a1",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#2c2645",
  
      "color-shimmer": "#665e96",
      "color-shimmer-light": "#efeaf6",
      "color-progress": "#EBC18F",
      "color-selection": "#f3d7b2",
  
      "color-tab": "#EBC18F",
      "color-tab-shadown": "#b89168",
      "color-tab-primary": "#49426E",
      "color-on-tab": "#725C42"
    }
  },  
  {
    "name": "vibrant-yellow-purple",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#ffc001",
      "color-background-center": "#fecb01",
      "color-text": "#401835",
  
      "color-primary": "#ffac00",
      "color-on-primary": "#630B7D",
      "color-primary-light": "#9C3772",
      "color-primary-container": "#630B7D",
  
      "color-secondary": "#630B7D",
      "color-on-secondary": "#fec601",
      "color-hint": "#630B7D",
      "color-highlight": "#843162",
      "color-secondary-container": "#853162",
  
      "color-bg": "#ffda47",
      "color-on-bg": "#630B7D",
      "color-canvas": "#e69b00",
      "color-divider": "#fee301",
  
      "color-surface": "#ffda47",
      "color-on-surface": "#630B7D",
      "color-box-shadown": "#c58c00",
  
      "color-shimmer": "#ffda47",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#630B7D",
      "color-tab-shadown": "#520868",
      "color-tab-primary": "#fec601",
      "color-on-tab": "#FFFFFF"
    }
  },
  {
    "name": "bright-yellow-blue",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#ffcb19",
      "color-background-center": "#ffe07a",
      "color-text": "#0a0f23",
  
      "color-primary": "#122373",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#FFD42F",
  
      "color-secondary": "#122373",
      "color-on-secondary": "#FFD42F",
      "color-hint": "#122373",
      "color-highlight": "#7a5b00",
      "color-secondary-container": "#9E7600",
  
      "color-bg": "#ffe07a",
      "color-on-bg": "#000f45",
      "color-canvas": "#ffcb19",
      "color-divider": "#D3A600",
  
      "color-surface": "#ffdc6b",
      "color-on-surface": "#122373",
      "color-box-shadown": "#b99000",
  
      "color-shimmer": "#ffdd6c",
      "color-shimmer-light": "#c59600",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#122373",
      "color-tab-shadown": "#0A1337",
      "color-tab-primary": "#FFD42F",
      "color-on-tab": "#c9ebff"
    }
  },
  {
    "name": "bright-yellow-black2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#facb01",
      "color-background-center": "#ffe152",
      "color-text": "#230F0A",
  
      "color-primary": "#f6bb14",
      "color-on-primary": "#000000",
      "color-primary-light": "#60411b",
      "color-primary-container": "#000000",
  
      "color-secondary": "#000000",
      "color-on-secondary": "#FFD42F",
      "color-hint": "#010100",
      "color-highlight": "#5B4400",
      "color-secondary-container": "#806000",
  
      "color-bg": "#ffe152",
      "color-on-bg": "#0E0303",
      "color-canvas": "#facb01",
      "color-divider": "#D3A600",
  
      "color-surface": "#FFE66C",
      "color-on-surface": "#000000",
      "color-box-shadown": "#b99000",
  
      "color-shimmer": "#FFDA34",
      "color-shimmer-light": "#FFF4C2",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#000000",
      "color-tab-shadown": "#000000",
      "color-tab-primary": "#ffd400",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "bright-yellow-black",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#fadc3e",
      "color-background-center": "#FFE476",
      "color-text": "#1F0E09",
  
      "color-primary": "#000000",
      "color-on-primary": "#fadc3e",
      "color-primary-light": "#AA8353",
      "color-primary-container": "#fadc3e",
  
      "color-secondary": "#000000",
      "color-on-secondary": "#fadc3e",
      "color-hint": "#000000",
      "color-highlight": "#7a5b00",
      "color-secondary-container": "#9E7600",
  
      "color-bg": "#FFF0A2",
      "color-on-bg": "#000f45",
      "color-canvas": "#fadc3e",
      "color-divider": "#D3A600",
  
      "color-surface": "#FFF0A2",
      "color-on-surface": "#60411b",
      "color-box-shadown": "#b99000",
  
      "color-shimmer": "#ffdd6c",
      "color-shimmer-light": "#c59600",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#000000",
      "color-tab-shadown": "#000000",
      "color-tab-primary": "#fbd022",
      "color-on-tab": "#AA8353"
    }
  },
  {
    "name": "bright-yellow-black3",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f6cb24",
      "color-background-center": "#ffe07a",
      "color-text": "#000000",
  
      "color-primary": "#000000",
      "color-on-primary": "#f6cb24",
      "color-primary-light": "#ffffff",
      "color-primary-container": "#f6cb24",
  
      "color-secondary": "#000000",
      "color-on-secondary": "#f6cb24",
      "color-hint": "#000000",
      "color-highlight": "#000000",
      "color-secondary-container": "#54420B",
  
      "color-bg": "#F9E57F",
      "color-on-bg": "#000f45",
      "color-canvas": "#f6cb24",
      "color-divider": "#D3A600",
  
      "color-surface": "#F9E57F",
      "color-on-surface": "#60411b",
      "color-box-shadown": "#b99000",
  
      "color-shimmer": "#ffdd6c",
      "color-shimmer-light": "#c59600",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#000000",
      "color-tab-shadown": "#171304",
      "color-tab-primary": "#f6cb24",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "vibrant-orange-deepblue",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f88d20",
      "color-background-center": "#fbb41c",
      "color-text": "#281604",
  
      "color-primary": "#002754",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ff8d00",
  
      "color-secondary": "#002754",
      "color-on-secondary": "#ff8d00",
      "color-hint": "#002754",
      "color-highlight": "#6E2D0D",
      "color-secondary-container": "#9a3907",
  
      "color-bg": "#fbb41c",
      "color-on-bg": "#753E07",
      "color-canvas": "#f88d20",
      "color-divider": "#c6551e",
  
      "color-surface": "#fbb41c",
      "color-on-surface": "#002754",
      "color-box-shadown": "#ab3c07",
  
      "color-shimmer": "#f99b1e",
      "color-shimmer-light": "#FBD9BB",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#002754",
      "color-tab-shadown": "#001F42",
      "color-tab-primary": "#ff8d00",
      "color-on-tab": "#c9ebff"
    }
  },
  {
    "name": "laranja-eletrico",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e0efff",
      "color-background-center": "#ffffff",
      "color-text": "#212121",
  
      "color-primary": "#ff9800",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffe5c9",
      "color-primary-container": "#ffe0b2",
  
      "color-secondary": "#673ab7",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#673ab7",
      "color-highlight": "#ba68c8",
      "color-secondary-container": "#9875d6",
  
      "color-bg": "#e0efff",
      "color-on-bg": "#9875d6",
      "color-canvas": "#e0efff",
      "color-divider": "#f57c00",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#673ab7",
      "color-box-shadown": "#f57c00",
  
      "color-shimmer": "#ffffff",
      "color-shimmer-light": "#ffe0b2",
      "color-progress": "#f57c00",
      "color-selection": "#f57c00",
  
      "color-tab": "#ff9800",
      "color-tab-shadown": "#e65100",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#994f00"
    }
  },
  {
    "name": "amber-sun",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#FFA708",
      "color-background-center": "#ffc042",
      "color-text": "#402000",
  
      "color-primary": "#ff8f00",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#ffd54f",
      "color-primary-container": "#ffb300",
  
      "color-secondary": "#6b3f00",
      "color-on-secondary": "#ffc042",
      "color-hint": "#6b3f00",
      "color-highlight": "#fff1b9",
      "color-secondary-container": "#fff1b9",
  
      "color-bg": "#e69a07",
      "color-on-bg": "#ffffff",
      "color-canvas": "#FFA708",
      "color-divider": "#ffcc80",
  
      "color-surface": "#ffc042",
      "color-on-surface": "#6b3f00",
      "color-box-shadown": "#a66700",
  
      "color-shimmer": "#ffe9b3",
      "color-shimmer-light": "#fff8e1",
      "color-progress": "#f80000",
      "color-selection": "#ffcc80",
  
      "color-tab": "#d17b00",
      "color-tab-shadown": "#bf7000",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#ffe082"
    }
  },
  {
    "name": "sun-sand",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#E9C46A",
      "color-background-center": "#f1d182",
      "color-text": "#4b3a00",
  
      "color-primary": "#d6a600",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#ffe082",
      "color-primary-container": "#ffcc00",
  
      "color-secondary": "#755a18",
      "color-on-secondary": "#3e3000",
      "color-hint": "#755a18",
      "color-highlight": "#fff6d9",
      "color-secondary-container": "#fff6d9",
  
      "color-bg": "#d0b35f",
      "color-on-bg": "#ffffff",
      "color-canvas": "#E9C46A",
      "color-divider": "#ffeea9",
  
      "color-surface": "#f3d373",
      "color-on-surface": "#755a18",
      "color-box-shadown": "#9a7c1f",
  
      "color-shimmer": "#fceaa0",
      "color-shimmer-light": "#fff8e1",
      "color-progress": "#f80000",
      "color-selection": "#ffe082",
  
      "color-tab": "#c9a944",
      "color-tab-shadown": "#d9b000",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#755a18"
    }
  },
  {
    "name": "peach-sunset",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#F3A361",
      "color-background-center": "#f5b076",
      "color-text": "#4a2e1b",
  
      "color-primary": "#e07e30",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#ffddc1",
      "color-primary-container": "#ffddc1",
  
      "color-secondary": "#4a2e1b",
      "color-on-secondary": "#f5b076",
      "color-hint": "#4a2e1b",
      "color-highlight": "#ffffff",
      "color-secondary-container": "#ffffff",
  
      "color-bg": "#e3954e",
      "color-on-bg": "#3a1f0f",
      "color-canvas": "#F3A361",
      "color-divider": "#fddbb3",
  
      "color-surface": "#ffd0a8",
      "color-on-surface": "#4a2e1b",
      "color-box-shadown": "#a35720",
  
      "color-shimmer": "#fcd1a0",
      "color-shimmer-light": "#fff3e0",
      "color-progress": "#f80000",
      "color-selection": "#ffccbc",
  
      "color-tab": "#e07e30",
      "color-tab-shadown": "#b96525",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#ffe0c3"
    }
  },
  {
    name: "vibrant-sunset",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#ff6347",
      "color-background-center": "#ff7f50",
      "color-text": "#ffffff",
  
      "color-primary": "#ff4500",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#ff9e80",
      "color-primary-container": "#ffb74d",
  
      "color-secondary": "#793820",
      "color-on-secondary": "#ff4500",
      "color-hint": "#793820",
      "color-highlight": "#ffcfc0",
      "color-secondary-container": "#ffcfc0",
  
      "color-bg": "#ff6347",
      "color-on-bg": "#ffcfc0",
      "color-canvas": "#ff6347",
      "color-divider": "#d32f2f",
  
      "color-surface": "#ff9c78",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#c2185b",
  
      "color-shimmer": "#ff9c78",
      "color-shimmer-light": "#ffd180",
      "color-progress": "#f44336",
      "color-selection": "#d32f2f",
  
      "color-tab": "#ffb74d",
      "color-tab-shadown": "#d84315",
      "color-tab-primary": "#bf3c0c",
      "color-on-tab": "#793820"
    }
  },
  {
    "name": "sunset-clay",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#E76F51",
      "color-background-center": "#ee8c70",
      "color-text": "#3e1b14",
  
      "color-primary": "#d14a2a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#ffab91",
      "color-primary-container": "#f97a5e",
  
      "color-secondary": "#952c13",
      "color-on-secondary": "#ee8c70",
      "color-hint": "#ffffff",
      "color-highlight": "#ffd7cb",
      "color-secondary-container": "#ffd7cb",
  
      "color-bg": "#cc6147",
      "color-on-bg": "#ffffff",
      "color-canvas": "#E76F51",
      "color-divider": "#ffc4af",
  
      "color-surface": "#f6a48d",
      "color-on-surface": "#952c13",
      "color-box-shadown": "#8e3929",
  
      "color-shimmer": "#ffc2b0",
      "color-shimmer-light": "#ffe5de",
      "color-progress": "#f80000",
      "color-selection": "#ffab91",
  
      "color-tab": "#d14a2a",
      "color-tab-shadown": "#b5472e",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#ffcdbb"
    }
  },
  {
    "name": "light-blue-red-yellow",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#dae7f0",
      "color-background-center": "#ffffff",
      "color-text": "#1c262e",
  
      "color-primary": "#ed3237",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffbabc",
      "color-primary-container": "#feae00",
  
      "color-secondary": "#004687",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#527ea8",
      "color-highlight": "#7196b7",
      "color-secondary-container": "#8faeca",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#527ea8",
      "color-canvas": "#cde0ef",
      "color-divider": "#b9cede",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#264b65",
      "color-box-shadown": "#cadceb",
  
      "color-shimmer": "#a0bbd4",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ed3237",
      "color-tab-shadown": "#ae1115",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#ffbabc"
    }
  },
  
  {
    "name": "light-red",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#d9e3eb",
      "color-background-center": "#ffffff",
      "color-text": "#242323",
  
      "color-primary": "#dd0510",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#FFD5D7",
      "color-primary-container": "#FFD5D7",
  
      "color-secondary": "#dd0510",
      "color-on-secondary": "#ffffff",
      "color-hint": "#6c889d",
      "color-highlight": "#6c889d",
      "color-secondary-container": "#899FAF",
  
      "color-bg": "#6c889d",
      "color-on-bg": "#ffffff",
      "color-canvas": "#d9e3eb",
      "color-divider": "#2a667f",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#dd0510",
      "color-box-shadown": "#232428",
  
      "color-shimmer": "#ffffff",
      "color-shimmer-light": "#BCD2E5",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#dd0510",
      "color-tab-shadown": "#C2000A",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#ffb0b0"
    }
  },
  {
    "name": "light-blue-red2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e5f1ff",
      "color-background-center": "#ffffff",
      "color-text": "#1a2c3f",
  
      "color-primary": "#daedff",
      "color-on-primary": "#4b7190",
      "color-primary-light": "#5379a2",
      "color-primary-container": "#990100",
  
      "color-secondary": "#990100",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#990100",
      "color-highlight": "#054589",
      "color-secondary-container": "#6190b5",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#6190b5",
      "color-canvas": "#e5f1ff",
      "color-divider": "#a7c9ec",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#375b83",
      "color-box-shadown": "#76abe3",
  
      "color-shimmer": "#daedff",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#d72924",
      "color-tab-shadown": "#9C0E0C",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#f3c3c3"
    }
  },
  {
    "name": "light-neutral-redaccent",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f3f4f5",
      "color-background-center": "#ffffff",
      "color-text": "#1a1e21",
  
      "color-primary": "#FFFFFF",
      "color-on-primary": "#22263f",
      "color-primary-light": "#3a4377",
      "color-primary-container": "#cb2019",
  
      "color-secondary": "#091a68",
      "color-on-secondary": "#ffffff",
      "color-hint": "#091a68",
      "color-highlight": "#091a68",
      "color-secondary-container": "#868998",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#5b6db7",
      "color-canvas": "#f3f4f5",
      "color-divider": "#dbe0e4",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#091a68",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#dbe0e4",
      "color-shimmer-light": "#ffffff",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#cb2019",
      "color-tab-shadown": "#b11711",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#fed5d3"
    }
  },
  {
    "name": "vibrant-red-yellow",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f4f6f7",
      "color-background-center": "#ffffff",
      "color-text": "#1a2c3e",
  
      "color-primary": "#d9351f",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#FFCCC5",
      "color-primary-container": "#FFD21C",
  
      "color-secondary": "#d9351f",
      "color-on-secondary": "#FFD21C",
      "color-hint": "#091b68",
      "color-highlight": "#002d7a",
      "color-secondary-container": "#5c6db7",
  
      "color-bg": "#FFFFFF",
      "color-on-bg": "#5c6db7",
      "color-canvas": "#E0F3FF",
      "color-divider": "#a7c9ec",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#091b68",
      "color-box-shadown": "#121650",
  
      "color-shimmer": "#c6e0f0",
      "color-shimmer-light": "#FFFFFF",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#d9351f",
      "color-tab-shadown": "#AF2310",
      "color-tab-primary": "#FFD21C",
      "color-on-tab": "#FFCCC5"
    }
  },
  {
    "name": "light-blue-green-red",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e5ecf4",
      "color-background-center": "#ffffff",
      "color-text": "#2E2E2E",
  
      "color-primary": "#30773C",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#CCE7FF",
      "color-primary-container": "#FABB0D",
  
      "color-secondary": "#6d6a6c",
      "color-on-secondary": "#ffffff",
      "color-hint": "#3D3D3D",
      "color-highlight": "#3C4055",
      "color-secondary-container": "#8E96A1",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#A0A0A0",
      "color-canvas": "#CDCDCD",
      "color-divider": "#dbe0e4",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#4C4C4C",
      "color-box-shadown": "#181A39",
  
      "color-shimmer": "#E6E6E6",
      "color-shimmer-light": "#ffffff",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#A61914",
      "color-tab-shadown": "#90130F",
      "color-tab-primary": "#FABB0D",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "terra-cotta-aconchegante",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#ffccbc",
      "color-background-center": "#fbe9e7",
      "color-text": "#212121",
  
      "color-primary": "#d32f2f",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffa29b",
      "color-primary-container": "#ef5350",
  
      "color-secondary": "#d32f2f",
      "color-on-secondary": "#fbe9e7",
      "color-hint": "#d32f2f",
      "color-highlight": "#c25454",
      "color-secondary-container": "#c25454",
  
      "color-bg": "#ffccbc",
      "color-on-bg": "#d32f2f",
      "color-canvas": "#ffccbc",
      "color-divider": "#c62828",
  
      "color-surface": "#f9fbe7",
      "color-on-surface": "#873030",
      "color-box-shadown": "#c62828",
  
      "color-shimmer": "#ff8a65",
      "color-shimmer-light": "#ffccbc",
      "color-progress": "#c62828",
      "color-selection": "#c62828",
  
      "color-tab": "#d32f2f",
      "color-tab-shadown": "#9a0007",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#ffa7a7"
    }
  },
  {
    "name": "deep-red-white",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#c41820",
      "color-background-center": "#BC0A16",
      "color-text": "#FFFFFF",
  
      "color-primary": "#a2141b",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffd2d1",
      "color-primary-container": "#FFFFFF",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#a2141b",
      "color-hint": "#ffffff",
      "color-highlight": "#ffffff",
      "color-secondary-container": "#ffd2d1",
  
      "color-bg": "#BC0A16",
      "color-on-bg": "#ffffff",
      "color-canvas": "#85010E",
      "color-divider": "#CF091D",
  
      "color-surface": "#e42630",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#86090f",
  
      "color-shimmer": "#b11a25",
      "color-shimmer-light": "#FBBBBC",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#f3c7ca",
      "color-tab-primary": "#ce1a23",
      "color-on-tab": "#EC7575"
    }
  },
  
  {
    "name": "deep-red-white3",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#b31720",
      "color-background-center": "#ba1923",
      "color-text": "#FFFFFF",
  
      "color-primary": "#a2141b",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#E4C8C8",
      "color-primary-container": "#FFFFFF",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#a2141b",
      "color-hint": "#ffffff",
      "color-highlight": "#ffffff",
      "color-secondary-container": "#ffd2d1",
  
      "color-bg": "#ba1923",
      "color-on-bg": "#ffffff",
      "color-canvas": "#6B000B",
      "color-divider": "#CF091D",
  
      "color-surface": "#F0545E",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#810A10",
  
      "color-shimmer": "#b11a25",
      "color-shimmer-light": "#FBBBBC",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab-primary": "#b31720",
      "color-on-tab": "#967676",
      "color-tab": "#ffffff",
      "color-tab-shadown": "#f3c7ca"
    }
  },
  {
    "name": "deep-red-white2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#700f14",
      "color-background-center": "#981C25",
      "color-text": "#FFFFFF",
  
      "color-primary": "#a2141b",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffd2d1",
      "color-primary-container": "#FFFFFF",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#a2141b",
      "color-hint": "#ffffff",
      "color-highlight": "#ffffff",
      "color-secondary-container": "#ffd2d1",
  
      "color-bg": "#981C25",
      "color-on-bg": "#ffffff",
      "color-canvas": "#6B000B",
      "color-divider": "#CF091D",
  
      "color-surface": "#921b23",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#560005",
  
      "color-shimmer": "#b11a25",
      "color-shimmer-light": "#FBBBBC",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab-primary": "#791116",
      "color-on-tab": "#BC8181",
      "color-tab": "#ffffff",
      "color-tab-shadown": "#f3c7ca"
    }
  },
  {
    "name": "magma-amarelo",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#5f0000",
      "color-background-center": "#8c1a00",
      "color-text": "#ffe8e6",
  
      "color-primary": "#8a0000",
      "color-on-primary": "#ffe8e6",
      "color-primary-light": "#f28989",
      "color-primary-container": "#ffcc00",
  
      "color-secondary": "#ffcc00",
      "color-on-secondary": "#5f0000",
      "color-hint": "#ffffff",
      "color-highlight": "#ffcc00",
      "color-secondary-container": "#f1f189",
  
      "color-bg": "#8b1e1e",
      "color-on-bg": "#ffcc00",
      "color-canvas": "#7e1616",
      "color-divider": "#ff4747",
  
      "color-surface": "#8b1e1e",
      "color-on-surface": "#ffe8e6",
      "color-box-shadown": "#3a0000",
  
      "color-shimmer": "#ff3300",
      "color-shimmer-light": "#bbfbfb",
      "color-progress": "#00ff47",
      "color-selection": "#b55d61",
  
      "color-tab": "#ffcc00",
      "color-tab-shadown": "#8c3737",
      "color-tab-primary": "#8a0000",
      "color-on-tab": "#bd7024"
    }
  },
  {
    name: "red",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#5f0000",
      "color-background-center": "#901818",
      "color-text": "#ffffff",
  
      "color-primary": "#5d0000",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#f28989",
      "color-primary-container": "#ff8a00",
  
      "color-secondary": "#ff8a00",
      "color-on-secondary": "#5d0000",
      "color-hint": "#f5a7a7",
      "color-highlight": "#ef9292",
      "color-secondary-container": "#f18989",
  
      "color-bg": "#cb3f3f",
      "color-on-bg": "#5d0000",
      "color-canvas": "#7e1616",
      "color-divider": "#ab2a2a",
  
      "color-surface": "#8b1e1e",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#560000",
  
      "color-shimmer": "#5d0000",
      "color-shimmer-light": "#fbbbbb",
      "color-progress": "#00f814",
      "color-selection": "#b56161",
  
      "color-tab": "#ff8a00",
      "color-tab-shadown": "#8c3737",
      "color-tab-primary": "#5d0000",
      "color-on-tab": "#8c3737"
    }
  },
  {
    name: "silver",
    colors: {
      "color-system": "#f0f0f0",
      "color-background": "#3d0000",
      "color-background-center": "#6b0505",
      "color-text": "#f5f5f5",
  
      "color-primary": "#5d0000",
      "color-on-primary": "#f5f5f5",
      "color-primary-light": "#e5b8b8",
      "color-primary-container": "#d10000",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#5d0000",
      "color-hint": "#e0e0e0",
      "color-highlight": "#e5b8b8",
      "color-secondary-container": "#e5b8b8",
  
      "color-bg": "#810e0e",
      "color-on-bg": "#e5b8b8",
      "color-canvas": "#3d0000",
      "color-divider": "#ab2a2a",
  
      "color-surface": "#851212",
      "color-on-surface": "#f5f5f5",
      "color-box-shadown": "#2a2a2a",
  
      "color-shimmer": "#cccccc",
      "color-shimmer-light": "#ffdddd",
      "color-progress": "#00d147",
      "color-selection": "#a5a5a5",
  
      "color-tab": "#ca2020",
      "color-tab-shadown": "#8c3737",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#e5b8b8"
    }
  },
  {
    "name": "deep-red-orange1",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#6c2e27",
      "color-background-center": "#913f35",
      "color-text": "#FFFFFF",
  
      "color-primary": "#65261f",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#bb6d66",
      "color-primary-container": "#de7146",
  
      "color-secondary": "#F57531",
      "color-on-secondary": "#401914",
      "color-hint": "#FFFFFF",
      "color-highlight": "#ebb8b2",
      "color-secondary-container": "#EF855E",
  
      "color-bg": "#913f35",
      "color-on-bg": "#FFFFFF",
      "color-canvas": "#6c2e27",
      "color-divider": "#AB5B52",
  
      "color-surface": "#b7564a",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#3a1611",
  
      "color-shimmer": "#7f362d",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#de7146",
      "color-tab-shadown": "#a14621",
      "color-tab-primary": "#7d2d27",
      "color-on-tab": "#ffffff"
    }
  },
  
  {
    "name": "deep-red-gold",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#3c110b",
      "color-background-center": "#781f1e",
      "color-text": "#FFFFFF",
  
      "color-primary": "#330400",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#e4bdb2",
      "color-primary-container": "#ffd76b",
  
      "color-secondary": "#ffd76b",
      "color-on-secondary": "#3c110b",
      "color-hint": "#eaceb7",
      "color-highlight": "#d7bab7",
      "color-secondary-container": "#c7a5a2",
  
      "color-bg": "#781f1e",
      "color-on-bg": "#c7a5a2",
      "color-canvas": "#570d0c",
      "color-divider": "#7c2525",
  
      "color-surface": "#5f1919",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#3D0B03",
  
      "color-shimmer": "#340d09",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#2B0400",
      "color-tab-shadown": "#5D0000",
      "color-tab-primary": "#ffd76b",
      "color-on-tab": "#e4bdb2"
    }
  },
  {
    "name": "deep-brown-orange",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#3b1709",
      "color-background-center": "#552412",
      "color-text": "#FFFFFF",
  
      "color-primary": "#2c1005",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffe4d9",
      "color-primary-container": "#f58634",
  
      "color-secondary": "#f58634",
      "color-on-secondary": "#2c1005",
      "color-hint": "#ffffff",
      "color-highlight": "#ffe4d9",
      "color-secondary-container": "#9f563a",
  
      "color-bg": "#552412",
      "color-on-bg": "#ffd6c6",
      "color-canvas": "#270d03",
      "color-divider": "#54230f",
  
      "color-surface": "#83432c",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#1d0900",
  
      "color-shimmer": "#602a14",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#f58634",
      "color-tab-shadown": "#a84700",
      "color-tab-primary": "#301206",
      "color-on-tab": "#913e00"
    }
  },
  {
    name: "clay",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#3d1a00",
      "color-background-center": "#683000",
      "color-text": "#ffffff",
  
      "color-primary": "#5d2a00",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#f2b689",
      "color-primary-container": "#ff8a3e",
  
      "color-secondary": "#ff8a3e",
      "color-on-secondary": "#5d2a00",
      "color-hint": "#f5c9a7",
      "color-highlight": "#efb992",
      "color-secondary-container": "#f1a189",
  
      "color-bg": "#cb6a3f",
      "color-on-bg": "#5d2a00",
      "color-canvas": "#7e3d16",
      "color-divider": "#ab4e2a",
  
      "color-surface": "#8b4a1e",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#562200",
  
      "color-shimmer": "#5d3400",
      "color-shimmer-light": "#fbddbb",
      "color-progress": "#00a2ff",
      "color-selection": "#b58261",
  
      "color-tab": "#ff8a3e",
      "color-tab-shadown": "#8c4e37",
      "color-tab-primary": "#5d2a00",
      "color-on-tab": "#8c4e37"
    }
  },
  {
    "name": "sunset-orange",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#3b1b00",
      "color-background-center": "#5e2a00",
      "color-text": "#ffffff",
  
      "color-primary": "#e65100",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#ffcc80",
      "color-primary-container": "#ffa726",
  
      "color-secondary": "#ff9800",
      "color-on-secondary": "#3b1b00",
      "color-hint": "#ffb74d",
      "color-highlight": "#ffcc80",
      "color-secondary-container": "#ffb74d",
  
      "color-bg": "#ef6c00",
      "color-on-bg": "#fff3e0",
      "color-canvas": "#6d2c00",
      "color-divider": "#a84300",
  
      "color-surface": "#5e2a00",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#3a1a00",
  
      "color-shimmer": "#ef6c00",
      "color-shimmer-light": "#ffe0b2",
      "color-progress": "#f80000",
      "color-selection": "#ffb74d",
  
      "color-tab": "#ffa726",
      "color-tab-shadown": "#b26500",
      "color-tab-primary": "#5e2a00",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "deep-brown-goldaccent",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#221109",
      "color-background-center": "#381c10",
      "color-text": "#FFFFFF",
  
      "color-primary": "#231109",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#c6a293",
      "color-primary-container": "#f0c556",
  
      "color-secondary": "#f0c556",
      "color-on-secondary": "#221009",
      "color-hint": "#fff3b5",
      "color-highlight": "#fff8d5",
      "color-secondary-container": "#cab2a7",
  
      "color-bg": "#381c10",
      "color-on-bg": "#956F51",
      "color-canvas": "#462416",
      "color-divider": "#402113",
  
      "color-surface": "#341a0e",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#211103",
  
      "color-shimmer": "#442215",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ecaa4b",
      "color-tab-shadown": "#D0913A",
      "color-tab-primary": "#1d0e07",
      "color-on-tab": "#8D5B16"
    }
  },
  {
    name: "gold",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#2a0a00",
      "color-background-center": "#5a1a10",
      "color-text": "#ffffff",
  
      "color-primary": "#3d1e00",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#f2d289",
      "color-primary-container": "#d4af37",
  
      "color-secondary": "#d4af37",
      "color-on-secondary": "#3d1e00",
      "color-hint": "#f5e0a7",
      "color-highlight": "#efd492",
      "color-secondary-container": "#f1d189",
  
      "color-bg": "#cb9e3f",
      "color-on-bg": "#3d1e00",
      "color-canvas": "#7e4f16",
      "color-divider": "#ab7a2a",
  
      "color-surface": "#8b5e1e",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#563900",
  
      "color-shimmer": "#5d3d00",
      "color-shimmer-light": "#fbf0bb",
      "color-progress": "#ff3e3e",
      "color-selection": "#b59d61",
  
      "color-tab": "#d4af37",
      "color-tab-shadown": "#8c6a37",
      "color-tab-primary": "#3d1e00",
      "color-on-tab": "#8c6a37"
    }
  },
  {
    name: "chocolate",
    colors: {
      "color-system": "#fff5f0",
      "color-background": "#3d1a00",
      "color-background-center": "#5a2600",
      "color-text": "#fff0f5",
  
      "color-primary": "#5d2a00",
      "color-on-primary": "#fff0f5",
      "color-primary-light": "#f2b689",
      "color-primary-container": "#ff85b3",
  
      "color-secondary": "#eac5aa",
      "color-on-secondary": "#5d2a00",
      "color-hint": "#eac5aa",
      "color-highlight": "#eac5aa",
      "color-secondary-container": "#eac5aa",
  
      "color-bg": "#cb6a3f",
      "color-on-bg": "#3d1a00",
      "color-canvas": "#7e3d16",
      "color-divider": "#ab4e2a",
  
      "color-surface": "#8b4a1e",
      "color-on-surface": "#fff0f5",
      "color-box-shadown": "#562200",
  
      "color-shimmer": "#8b4a1e",
      "color-shimmer-light": "#fbbbd7",
      "color-progress": "#85ff47",
      "color-selection": "#b5828a",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "d3c7b4",
      "color-tab-primary": "#5d2a00",
      "color-on-tab": "#b49379"
    }
  },
  
  {
    "name": "vibrant-orange-blue",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#c57029",
      "color-background-center": "#e8924b",
      "color-text": "#ffffff",
  
      "color-primary": "#c76e24",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#8da1cd",
      "color-primary-container": "#ffc000",
  
      "color-secondary": "#596689",
      "color-on-secondary": "#ffffff",
      "color-hint": "#ffffff",
      "color-highlight": "#FFE3CC",
      "color-secondary-container": "#FFCCA2",
  
      "color-bg": "#FFF4EB",
      "color-on-bg": "#CD7227",
      "color-canvas": "#c6551e",
      "color-divider": "#FFCCA2",
  
      "color-surface": "#E28E4A",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#9C380A",
  
      "color-shimmer": "#e99c5d",
      "color-shimmer-light": "#965826",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#FFFFFF",
      "color-tab-shadown": "#F2EFEA",
      "color-tab-primary": "#CD7227",
      "color-on-tab": "#596689"
    }
  },
  {
    "name": "earthy-red-olive",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#ebe5d7",
      "color-background-center": "#f5f0e4",
      "color-text": "#2A2A2A",
  
      "color-primary": "#b1a999",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#5B4E4B",
      "color-primary-container": "#f8d8d2",
  
      "color-secondary": "#c4422a",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#c4422a",
      "color-highlight": "#757366",
      "color-secondary-container": "#757366",
  
      "color-bg": "#f5f0e4",
      "color-on-bg": "#4a4a4a",
      "color-canvas": "#e0d9c8",
      "color-divider": "#E7E2D8",
  
      "color-surface": "#f2f0e9",
      "color-on-surface": "#3E3C33",
      "color-box-shadown": "#7C756C",
  
      "color-shimmer": "#f2f0e9",
      "color-shimmer-light": "#f0e9dd",
      "color-progress": "#c4422a",
      "color-selection": "#d7cdb5",
  
      "color-tab": "#c4422a",
      "color-tab-shadown": "#AF3722",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#C6BDA8"
    }
  },
  {
    "name": "elegant-earth",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#ECE9E0",
      "color-background-center": "#f4f2ec",
      "color-text": "#184A3F",
  
      "color-primary": "#C68727",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#ffe0a1",
      "color-primary-container": "#deb057",
  
      "color-secondary": "#184A3F",
      "color-on-secondary": "#ffffff",
      "color-hint": "#987b42",
      "color-highlight": "#655638",
      "color-secondary-container": "#4a7368",
  
      "color-bg": "#f8f7f2",
      "color-on-bg": "#2b3f3a",
      "color-canvas": "#e0ddd4",
      "color-divider": "#d6d2c5",
  
      "color-surface": "#ffffff",
      "color-on-surface": "#184A3F",
      "color-box-shadown": "#d4d0c1",
  
      "color-shimmer": "#f3f1e7",
      "color-shimmer-light": "#ffffff",
      "color-progress": "#C68727",
      "color-selection": "#f2c56a",
  
      "color-tab": "#184A3F",
      "color-tab-shadown": "#99711f",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#ffe0a1"
    }
  },
  {
    "name": "light-beige-brown",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f3f4f5",
      "color-background-center": "#ffffff",
      "color-text": "#2d1e17",
  
      "color-primary": "#FFFFFF",
      "color-on-primary": "#2d1e17",
      "color-primary-light": "#FF9147",
      "color-primary-container": "#CD895B",
  
      "color-secondary": "#2d1e17",
      "color-on-secondary": "#ffffff",
      "color-hint": "#2d1e17",
      "color-highlight": "#654638",
      "color-secondary-container": "#76635B",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#C96726",
      "color-canvas": "#C7BDB5",
      "color-divider": "#C5B0A5",
  
      "color-surface": "#FFFFFF",
      "color-on-surface": "#2d1e17",
      "color-box-shadown": "#978887",
  
      "color-shimmer": "#DFCFCA",
      "color-shimmer-light": "#ffffff",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#2d1e17",
      "color-tab-shadown": "#241812",
      "color-tab-primary": "#FF9147",
      "color-on-tab": "#FFFFFF"
    }
  },
  {
    "name": "peach-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f8f0e8",
      "color-background-center": "#fdf9f5",
      "color-text": "#47413d",
  
      "color-primary": "#8a4e2a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#f2c8a8",
      "color-primary-container": "#ff9e6a",
  
      "color-secondary": "#b46a32",
      "color-on-secondary": "#ffffff",
      "color-hint": "#a8855a",
      "color-highlight": "#aa8e67",
      "color-secondary-container": "#ae9371",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#7f4a1f",
      "color-canvas": "#f6e8d6",
      "color-divider": "#eed9c5",
  
      "color-surface": "#faf2e8",
      "color-on-surface": "#695a45",
      "color-box-shadown": "#e7d6c5",
  
      "color-shimmer": "#f3e1c7",
      "color-shimmer-light": "#fbe3bb",
      "color-progress": "#00a347",
      "color-selection": "#b5a590",
  
      "color-tab": "#8a4e2a",
      "color-tab-shadown": "#482e0f",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#f2c8a8"
    }
  },
  {
    "name": "saffron-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#f8f4e8",
      "color-background-center": "#fdfbf5",
      "color-text": "#47433d",
  
      "color-primary": "#8a5d10",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#f2d689",
      "color-primary-container": "#ffb833",
  
      "color-secondary": "#b47a32",
      "color-on-secondary": "#ffffff",
      "color-hint": "#a88f5a",
      "color-highlight": "#aa9867",
      "color-secondary-container": "#ae9f71",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#7f521f",
      "color-canvas": "#f6ead6",
      "color-divider": "#e9dbc5",
  
      "color-surface": "#faf2e8",
      "color-on-surface": "#695d4a",
      "color-box-shadown": "#e7d9c5",
  
      "color-shimmer": "#f3e5c7",
      "color-shimmer-light": "#fbefbb",
      "color-progress": "#5d47ff",
      "color-selection": "#b5a890",
  
      "color-tab": "#8a5d10",
      "color-tab-shadown": "#48360f",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#f2d689"
    }
  },
  {
    "name": "bronze-elegante",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#cfd8dc",
      "color-background-center": "#eceff1",
      "color-text": "#212121",
  
      "color-primary": "#a1887f",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#d3b9af",
      "color-primary-container": "#c5b3a3",
  
      "color-secondary": "#4c616a",
      "color-on-secondary": "#FFFFFF",
      "color-hint": "#90a4ae",
      "color-highlight": "#6c7d85",
      "color-secondary-container": "#8b9ca4",
  
      "color-bg": "#cfd8dc",
      "color-on-bg": "#a1887f",
      "color-canvas": "#cfd8dc",
      "color-divider": "#795548",
  
      "color-surface": "#f5f5f5",
      "color-on-surface": "#212121",
      "color-box-shadown": "#795548",
  
      "color-shimmer": "#bcaaa4",
      "color-shimmer-light": "#e0f2f1",
      "color-progress": "#795548",
      "color-selection": "#795548",
  
      "color-tab": "#a1887f",
      "color-tab-shadown": "#4b3e39",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#bcaaa4"
    }
  },
  {
    "name": "aqua-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e0f8f5",
      "color-background-center": "#f5fdfc",
      "color-text": "#344747",
  
      "color-primary": "#006b5d",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#89d3c8",
      "color-primary-container": "#00b4a0",
  
      "color-secondary": "#007a8a",
      "color-on-secondary": "#ffffff",
      "color-hint": "#5aa8a1",
      "color-highlight": "#67aaa2",
      "color-secondary-container": "#71aeaa",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#005d52",
      "color-canvas": "#d6f6f0",
      "color-divider": "#cbe9e4",
  
      "color-surface": "#e8faf7",
      "color-on-surface": "#354949",
      "color-box-shadown": "#c5e7e2",
  
      "color-shimmer": "#c7f3eb",
      "color-shimmer-light": "#bbfbf0",
      "color-progress": "#ff3d3d",
      "color-selection": "#90b5b0",
  
      "color-tab": "#006b5d",
      "color-tab-shadown": "#004844",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#89d3c8"
    }
  },
  {
    "name": "mint-light",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#e8f8f0",
      "color-background-center": "#f5fdf9",
      "color-text": "#2d4738",
  
      "color-primary": "#006b3d",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#89f2b6",
      "color-primary-container": "#00d47a",
  
      "color-secondary": "#328a5a",
      "color-on-secondary": "#ffffff",
      "color-hint": "#5aa87d",
      "color-highlight": "#67aa85",
      "color-secondary-container": "#71ae8a",
  
      "color-bg": "#ffffff",
      "color-on-bg": "#1f7f4a",
      "color-canvas": "#d6f6e4",
      "color-divider": "#c5e9d5",
  
      "color-surface": "#e8faef",
      "color-on-surface": "#35493d",
      "color-box-shadown": "#c5e7d2",
  
      "color-shimmer": "#c7f3d9",
      "color-shimmer-light": "#bbfbdd",
      "color-progress": "#ff6b3d",
      "color-selection": "#90b5a3",
  
      "color-tab": "#006b3d",
      "color-tab-shadown": "#00482b",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#89f2b6"
    }
  },
  {
    "name": "vibrant-punch",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#00A49B",
      "color-background-center": "#25b7ae",
      "color-text": "#ffffff",
  
      "color-primary": "#E33C34",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#f58b85",
      "color-primary-container": "#EB4E2A",
  
      "color-secondary": "#F6E606",
      "color-on-secondary": "#1d1d1d",
      "color-hint": "#f9f588",
      "color-highlight": "#fdf272",
      "color-secondary-container": "#f9f36b",
  
      "color-bg": "#01867f",
      "color-on-bg": "#ffffff",
      "color-canvas": "#017872",
      "color-divider": "#23c6bd",
  
      "color-surface": "#2cbab1",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#005852",
  
      "color-shimmer": "#0fbfb5",
      "color-shimmer-light": "#d7f6f4",
      "color-progress": "#E33C34",
      "color-selection": "#fdf272",
  
      "color-tab": "#EB4E2A",
      "color-tab-shadown": "#aa3022",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#f9c6bd"
    }
  },

  {
    name: "green",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#003d1c",
      "color-background-center": "#00682d",
      "color-text": "#ffffff",
  
      "color-primary": "#003d1b",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#89f2b6",
      "color-primary-container": "#ffd700",
  
      "color-secondary": "#ffd700",
      "color-on-secondary": "#003d1b",
      "color-hint": "#a7f5d1",
      "color-highlight": "#92efc4",
      "color-secondary-container": "#89f1c1",
  
      "color-bg": "#3fcb8c",
      "color-on-bg": "#003d1b",
      "color-canvas": "#167e51",
      "color-divider": "#2aab6f",
  
      "color-surface": "#1e8b5c",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#005639",
  
      "color-shimmer": "#005d3d",
      "color-shimmer-light": "#bbfbd7",
      "color-progress": "#f80000",
      "color-selection": "#90b5a8",
  
      "color-tab": "#ffd700",
      "color-tab-shadown": "#378c5e",
      "color-tab-primary": "#003d1b",
      "color-on-tab": "#378c5e"
    }
  },
  {
    "name": "jungle-sun",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0C3A2D",
      "color-background-center": "#105042",
      "color-text": "#ffffff",
  
      "color-primary": "#FEC202",
      "color-on-primary": "#0C3A2D",
      "color-primary-light": "#ffe385",
      "color-primary-container": "#f9d34b",
  
      "color-secondary": "#FEC202",
      "color-on-secondary": "#0C3A2D",
      "color-hint": "#FFFFFF",
      "color-highlight": "#e9dbca",
      "color-secondary-container": "#b5a390",
  
      "color-bg": "#0C3A2D",
      "color-on-bg": "#ffffff",
      "color-canvas": "#185f4a",
      "color-divider": "#2a6c58",
  
      "color-surface": "#1d4e3e",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#082a21",
  
      "color-shimmer": "#1a5e4b",
      "color-shimmer-light": "#d8f6eb",
      "color-progress": "#FEC202",
      "color-selection": "#ffe385",
  
      "color-tab": "#FEC202",
      "color-tab-shadown": "#b58f02",
      "color-tab-primary": "#0C3A2D",
      "color-on-tab": "#806F3A"
    }
  },
  {
    "name": "jungle-sun-clear",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0C3A2D",
      "color-background-center": "#105042",
      "color-text": "#ffffff",
  
      "color-primary": "#06281E",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffe385",
      "color-primary-container": "#f9d34b",
  
      "color-secondary": "#FEC202",
      "color-on-secondary": "#0C3A2D",
      "color-hint": "#FFFFFF",
      "color-highlight": "#e9dbca",
      "color-secondary-container": "#b5a390",
  
      "color-bg": "#0C3A2D",
      "color-on-bg": "#ffffff",
      "color-canvas": "#185f4a",
      "color-divider": "#2a6c58",
  
      "color-surface": "#1d4e3e",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#082a21",
  
      "color-shimmer": "#1a5e4b",
      "color-shimmer-light": "#d8f6eb",
      "color-progress": "#FEC202",
      "color-selection": "#ffe385",
  
      "color-tab": "#FFFFFF",
      "color-tab-shadown": "#b58f02",
      "color-tab-primary": "#0C3A2D",
      "color-on-tab": "#806F3A"
    }
  }, 
  {
    "name": "green-nature",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0e2f1c",
      "color-background-center": "#1e4d33",
      "color-text": "#ffffff",
  
      "color-primary": "#1f5e3d",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#a4d4b2",
      "color-primary-container": "#4caf50",
  
      "color-secondary": "#81c784",
      "color-on-secondary": "#1f3f2a",
      "color-hint": "#b2dfdb",
      "color-highlight": "#a5d6a7",
      "color-secondary-container": "#66bb6a",
  
      "color-bg": "#2e7d32",
      "color-on-bg": "#d0e4d3",
      "color-canvas": "#1b3b2d",
      "color-divider": "#356e4c",
  
      "color-surface": "#1d4a36",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#0b1f14",
  
      "color-shimmer": "#2e7d32",
      "color-shimmer-light": "#c8e6c9",
      "color-progress": "#f44336",
      "color-selection": "#81c784",
  
      "color-tab": "#4caf50",
      "color-tab-shadown": "#2e7d32",
      "color-tab-primary": "#1f5e3d",
      "color-on-tab": "#ffffff"
    }
  },
  {
    name: "cyan",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#005f5f",
      "color-background-center": "#189090",
      "color-text": "#ffffff",
  
      "color-primary": "#005d5d",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#89f2f2",
      "color-primary-container": "#ff52c5",
  
      "color-secondary": "#004343",
      "color-on-secondary": "#ffffff",
      "color-hint": "#a7f5f5",
      "color-highlight": "#92efef",
      "color-secondary-container": "#89f1f1",
  
      "color-bg": "#3fcbcb",
      "color-on-bg": "#005d5d",
      "color-canvas": "#167e7e",
      "color-divider": "#2aabab",
  
      "color-surface": "#1e8b8b",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#005656",
  
      "color-shimmer": "#005d5d",
      "color-shimmer-light": "#bbfbfb",
      "color-progress": "#f80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ff52c5",
      "color-tab-shadown": "#378c8c",
      "color-tab-primary": "#005d5d",
      "color-on-tab": "#8c4777"
    }
  },
  {
    name: "coral",
    colors: {
      "color-system": "#fafafa",
      "color-background": "#003d3d",
      "color-background-center": "#006868",
      "color-text": "#ffffff",
  
      "color-primary": "#005d5d",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#89f2f2",
      "color-primary-container": "#ff7f6e",
  
      "color-secondary": "#ff7f6e",
      "color-on-secondary": "#005d5d",
      "color-hint": "#a7f5f5",
      "color-highlight": "#ff9c92",
      "color-secondary-container": "#f18989",
  
      "color-bg": "#3fcbcb",
      "color-on-bg": "#005d5d",
      "color-canvas": "#167e7e",
      "color-divider": "#2aabab",
  
      "color-surface": "#1e8b8b",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#005656",
  
      "color-shimmer": "#00a2a2",
      "color-shimmer-light": "#bbfbfb",
      "color-progress": "#ff4d4d",
      "color-selection": "#90b5b5",
  
      "color-tab": "#ff7f6e",
      "color-tab-shadown": "#8c5a37",
      "color-tab-primary": "#005d5d",
      "color-on-tab": "#ffffff"
    }
  },
  {
    name: "peach",
    colors: {
      "color-system": "#fff5f0",
      "color-background": "#003d3a",
      "color-background-center": "#006862",
      "color-text": "#fff5f0",
  
      "color-primary": "#005d59",
      "color-on-primary": "#fff5f0",
      "color-primary-light": "#89f2e8",
      "color-primary-container": "#ff9c7a",
  
      "color-secondary": "#ff9c7a",
      "color-on-secondary": "#005d59",
      "color-hint": "#a7f5ec",
      "color-highlight": "#ffb492",
      "color-secondary-container": "#f1b289",
  
      "color-bg": "#3fcbb5",
      "color-on-bg": "#005d59",
      "color-canvas": "#167e74",
      "color-divider": "#2aab9e",
  
      "color-surface": "#1e8b7d",
      "color-on-surface": "#fff5f0",
      "color-box-shadown": "#00564f",
  
      "color-shimmer": "#00a294",
      "color-shimmer-light": "#bbfbf0",
      "color-progress": "#7a4dff",
      "color-selection": "#90b5ae",
  
      "color-tab": "#ffffff",
      "color-tab-shadown": "#8c5e37",
      "color-tab-primary": "#005d59",
      "color-on-tab": "#758074"
    }
  },
  {
    name: "yellow_green",
    colors: {
      "color-system": "#0a0a0a",
      "color-background": "#3d5f00",
      "color-background-center": "#5a8c00",
      "color-text": "#fffae6",
  
      "color-primary": "#4d6d00",
      "color-on-primary": "#fffae6",
      "color-primary-light": "#e3f289",
      "color-primary-container": "#f0ff47",
  
      "color-secondary": "#f0ff47",
      "color-on-secondary": "#3d5f00",
      "color-hint": "#e5f5a7",
      "color-highlight": "#f2ff6a",
      "color-secondary-container": "#e1f189",
  
      "color-bg": "#8fcb3f",
      "color-on-bg": "#3d5f00",
      "color-canvas": "#5a7e16",
      "color-divider": "#7aab2a",
  
      "color-surface": "#6a8b1e",
      "color-on-surface": "#fffae6",
      "color-box-shadown": "#2a5600",
  
      "color-shimmer": "#6a8b1e",
      "color-shimmer-light": "#fbfbbb",
      "color-progress": "#ff47b5",
      "color-selection": "#b5d561",
  
      "color-tab": "#f0ff47",
      "color-tab-shadown": "#8c8c37",
      "color-tab-primary": "#4d6d00",
      "color-on-tab": "#94a009"
    }
  },
  {
    "name": "teal-wave",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#299D8F",
      "color-background-center": "#4db5a7",
      "color-text": "#ffffff",
  
      "color-primary": "#1c7269",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#9de3da",
      "color-primary-container": "#37b2a2",
  
      "color-secondary": "#ffffff",
      "color-on-secondary": "#1c433e",
      "color-hint": "#b2dfdb",
      "color-highlight": "#b1f2eb",
      "color-secondary-container": "#b1f2eb",
  
      "color-bg": "#1f8477",
      "color-on-bg": "#ffffff",
      "color-canvas": "#18685f",
      "color-divider": "#52a99d",
  
      "color-surface": "#37b2a2",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#146057",
  
      "color-shimmer": "#6fd2c5",
      "color-shimmer-light": "#e0f2f1",
      "color-progress": "#f80000",
      "color-selection": "#80deea",
  
      "color-tab": "#084640",
      "color-tab-shadown": "#22675f",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#b2dfdb"
    }
  },
  {
    "name": "dark-metal",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#1C1D21",
      "color-background-center": "#2a2b30",
      "color-text": "#e0e0e0",
  
      "color-primary": "#44474f",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#b0bec5",
      "color-primary-container": "#5c5f66",
  
      "color-secondary": "#757575",
      "color-on-secondary": "#1C1D21",
      "color-hint": "#9e9e9e",
      "color-highlight": "#7f7f7f",
      "color-secondary-container": "#5c5c5c",
  
      "color-bg": "#2d2e32",
      "color-on-bg": "#ffffff",
      "color-canvas": "#111113",
      "color-divider": "#3d3d3d",
  
      "color-surface": "#2a2b2f",
      "color-on-surface": "#f5f5f5",
      "color-box-shadown": "#0e0e10",
  
      "color-shimmer": "#3c3d41",
      "color-shimmer-light": "#d1d1d1",
      "color-progress": "#f80000",
      "color-selection": "#90a4ae",
  
      "color-tab": "#5c5f66",
      "color-tab-shadown": "#2a2b30",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#b0bec5"
    }
  },
  {
    "name": "dark-blue2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#202022",
      "color-background-center": "#3a3c49",
      "color-text": "#FFFFFF",
  
      "color-primary": "#101010",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#C1E2FF",
      "color-primary-container": "#315bb1",
  
      "color-secondary": "#315bb1",
      "color-on-secondary": "#ffffff",
      "color-hint": "#DADEE8",
      "color-highlight": "#BABBC6",
      "color-secondary-container": "#AFB0B7",
  
      "color-bg": "#3a3c49",
      "color-on-bg": "#b6b9c7",
      "color-canvas": "#252527",
      "color-divider": "#363639",
  
      "color-surface": "#252527",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#08070c",
  
      "color-shimmer": "#222428",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#0b2f7a",
      "color-tab-shadown": "#062058",
      "color-tab-primary": "#ffffff",
      "color-on-tab": "#B0C7F6"
    }
  },
  {
    "name": "dark-blue5",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#202022",
      "color-background-center": "#3a3c49",
      "color-text": "#FFFFFF",
  
      "color-primary": "#101010",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#CDCDCD",
      "color-primary-container": "#5355bd",
  
      "color-secondary": "#5355bd",
      "color-on-secondary": "#ffffff",
      "color-hint": "#FFFFFF",
      "color-highlight": "#BABBC6",
      "color-secondary-container": "#AFB0B7",
  
      "color-bg": "#3a3c49",
      "color-on-bg": "#b6b9c7",
      "color-canvas": "#252527",
      "color-divider": "#363639",
  
      "color-surface": "#252527",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#08070c",
  
      "color-shimmer": "#222428",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#0F0F0F",
      "color-tab-shadown": "#000000",
      "color-tab-primary": "#5355bd",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "dark-golden2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#202022",
      "color-background-center": "#3a3c49",
      "color-text": "#FFFFFF",
  
      "color-primary": "#101010",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#FFF6C1",
      "color-primary-container": "#ffd715",
  
      "color-secondary": "#ffd715",
      "color-on-secondary": "#1A1A1A",
      "color-hint": "#ffd715",
      "color-highlight": "#D3D3DB",
      "color-secondary-container": "#AFB0B7",
  
      "color-bg": "#3a3c49",
      "color-on-bg": "#b6b9c7",
      "color-canvas": "#252527",
      "color-divider": "#363639",
  
      "color-surface": "#252527",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#08070c",
  
      "color-shimmer": "#222428",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffd715",
      "color-tab-shadown": "#DFBB08",
      "color-tab-primary": "#000000",
      "color-on-tab": "#85591f"
    }
  },
  
  
  {
    "name": "dark-yellow2",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0b0a0f",
      "color-background-center": "#18191d",
      "color-text": "#FFFFFF",
  
      "color-primary": "#000000",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#a2a5b8",
      "color-primary-container": "#fef60f",
  
      "color-secondary": "#fef60f",
      "color-on-secondary": "#020f2a",
      "color-hint": "#E4E4E4",
      "color-highlight": "#C4C4C4",
      "color-secondary-container": "#B4B4B4",
  
      "color-bg": "#18191d",
      "color-on-bg": "#b6b9c7",
      "color-canvas": "#3a3d4f",
      "color-divider": "#37393e",
  
      "color-surface": "#16171b",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#08070c",
  
      "color-shimmer": "#18191d",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#fef60f",
      "color-tab-shadown": "#FEDA0F",
      "color-tab-primary": "#000000",
      "color-on-tab": "#944200"
    }
  },
  {
    "name": "dark-yellow4",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#1f2125",
      "color-background-center": "#3a3c49",
      "color-text": "#FFFFFF",
  
      "color-primary": "#101010",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffecc1",
      "color-primary-container": "#fff200",
  
      "color-secondary": "#fff200",
      "color-on-secondary": "#1A1A1A",
      "color-hint": "#DADEE8",
      "color-highlight": "#BABBC6",
      "color-secondary-container": "#AFB0B7",
  
      "color-bg": "#3a3c49",
      "color-on-bg": "#999BA5",
      "color-canvas": "#252527",
      "color-divider": "#363639",
  
      "color-surface": "#252527",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#08070c",
  
      "color-shimmer": "#222428",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#fff200",
      "color-tab-shadown": "#dacf00",
      "color-tab-primary": "#000000",
      "color-on-tab": "#705E30"
    }
  },
  {
    "name": "dark-yellow",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#202022",
      "color-background-center": "#3a3c49",
      "color-text": "#FFFFFF",
  
      "color-primary": "#101010",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffecc1",
      "color-primary-container": "#ffb91d",
  
      "color-secondary": "#ffb91d",
      "color-on-secondary": "#1A1A1A",
      "color-hint": "#DADEE8",
      "color-highlight": "#BABBC6",
      "color-secondary-container": "#AFB0B7",
  
      "color-bg": "#3a3c49",
      "color-on-bg": "#b6b9c7",
      "color-canvas": "#252527",
      "color-divider": "#363639",
  
      "color-surface": "#252527",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#08070c",
  
      "color-shimmer": "#222428",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ffb91d",
      "color-tab-shadown": "#d79a13",
      "color-tab-primary": "#000000",
      "color-on-tab": "#85591f"
    }
  },
  {
    "name": "dark-orange",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#0b0a0f",
      "color-background-center": "#3a3c49",
      "color-text": "#FFFFFF",
  
      "color-primary": "#000000",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#a2a5b8",
      "color-primary-container": "#fd850a",
  
      "color-secondary": "#fd850a",
      "color-on-secondary": "#020f2a",
      "color-hint": "#E4E4E4",
      "color-highlight": "#C4C4C4",
      "color-secondary-container": "#B4B4B4",
  
      "color-bg": "#3a3c49",
      "color-on-bg": "#b6b9c7",
      "color-canvas": "#3a3d4f",
      "color-divider": "#37393e",
  
      "color-surface": "#16171b",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#08070c",
  
      "color-shimmer": "#262626",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#fd850a",
      "color-tab-shadown": "#0f1a48",
      "color-tab-primary": "#000000",
      "color-on-tab": "#944200"
    }
  },
  {
    name: "cyber",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#1a1a1a",
      "color-background-center": "#2d2d2d",
      "color-text": "#e6ffe6",
  
      "color-primary": "#2a2a2a",
      "color-on-primary": "#e6ffe6",
      "color-primary-light": "#a8cda1",
      "color-primary-container": "#00ff47",
  
      "color-secondary": "#00ff47",
      "color-on-secondary": "#1a1a1a",
      "color-hint": "#c5f5a7",
      "color-highlight": "#6aff92",
      "color-secondary-container": "#89f189",
  
      "color-bg": "#3d3d3d",
      "color-on-bg": "#00ff47",
      "color-canvas": "#2d2d2d",
      "color-divider": "#4aab2a",
  
      "color-surface": "#333333",
      "color-on-surface": "#e6ffe6",
      "color-box-shadown": "#1a1a1a",
  
      "color-shimmer": "#00ff66",
      "color-shimmer-light": "#bbfbcf",
      "color-progress": "#ff47ff",
      "color-selection": "#619061",
  
      "color-tab": "#00ff47",
      "color-tab-shadown": "#378c47",
      "color-tab-primary": "#2a2a2a",
      "color-on-tab": "#007721"
    }
  },
  
  {
    "name": "dark-purple-teal",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#202022",
      "color-background-center": "#3a3c49",
      "color-text": "#FFFFFF",
  
      "color-primary": "#101010",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#CDCDCD",
      "color-primary-container": "#AB66FE",
  
      "color-secondary": "#AB66FE",
      "color-on-secondary": "#1A1A1A",
      "color-hint": "#FFFFFF",
      "color-highlight": "#BABBC6",
      "color-secondary-container": "#AFB0B7",
  
      "color-bg": "#3a3c49",
      "color-on-bg": "#b6b9c7",
      "color-canvas": "#252527",
      "color-divider": "#363639",
  
      "color-surface": "#252527",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#08070c",
  
      "color-shimmer": "#222428",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#0F0F0F",
      "color-tab-shadown": "#000000",
      "color-tab-primary": "#4AAEAA",
      "color-on-tab": "#ffffff"
    }
  },
  
  {
    "name": "dark-pink",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#181818",
      "color-background-center": "#292929",
      "color-text": "#FFFFFF",
  
      "color-primary": "#262626",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#ffc1e4",
      "color-primary-container": "#ec008c",
  
      "color-secondary": "#ec008c",
      "color-on-secondary": "#000000",
      "color-hint": "#FFFFFF",
      "color-highlight": "#e8e8e8",
      "color-secondary-container": "#cdcdcd",
  
      "color-bg": "#292929",
      "color-on-bg": "#FFFFFF",
      "color-canvas": "#000000",
      "color-divider": "#1e1e1e",
  
      "color-surface": "#252525",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#000000",
  
      "color-shimmer": "#323232",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#F80000",
      "color-selection": "#6190b5",
  
      "color-tab": "#ec008c",
      "color-tab-shadown": "#aa0065",
      "color-tab-primary": "#000000",
      "color-on-tab": "#ffcdeb"
    }
  },
  {
    name: "blood",
    colors: {
      "color-system": "#ffffff",
      "color-background": "#0a0a0a",
      "color-background-center": "#1a1a1a",
      "color-text": "#ffeded",
  
      "color-primary": "#1a0000",
      "color-on-primary": "#ffeded",
      "color-primary-light": "#f28989",
      "color-primary-container": "#dc2222",
  
      "color-secondary": "#dc2222",
      "color-on-secondary": "#ffeded",
      "color-hint": "#FFFFFF",
      "color-highlight": "#e8e8e8",
      "color-secondary-container": "#cdcdcd",
  
      "color-bg": "#292929",
      "color-on-bg": "#ffeded",
      "color-canvas": "#1a0000",
      "color-divider": "#660000",
  
      "color-surface": "#252525",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#0d0000",
  
      "color-shimmer": "#5d0000",
      "color-shimmer-light": "#ffbbbb",
      "color-progress": "#00ff4d",
      "color-selection": "#8a5d5d",
  
      "color-tab": "#dc2222",
      "color-tab-shadown": "#8c0000",
      "color-tab-primary": "#1a0000",
      "color-on-tab": "#ff8080"
    }
  },
  {
    "name": "dark-red",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#312e2f",
      "color-background-center": "#3a3c49",
      "color-text": "#FFFFFF",
  
      "color-primary": "#101010",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#CDCDCD",
      "color-primary-container": "#D7434C",
  
      "color-secondary": "#D7434C",
      "color-on-secondary": "#1A1A1A",
      "color-hint": "#FFFFFF",
      "color-highlight": "#BABBC6",
      "color-secondary-container": "#AFB0B7",
  
      "color-bg": "#3a3c49",
      "color-on-bg": "#b6b9c7",
      "color-canvas": "#252527",
      "color-divider": "#363639",
  
      "color-surface": "#555153",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#1C1B1D",
  
      "color-shimmer": "#222428",
      "color-shimmer-light": "#bbdefb",
      "color-progress": "#bc2730",
      "color-selection": "#6190b5",
  
      "color-tab": "#0F0F0F",
      "color-tab-shadown": "#000000",
      "color-tab-primary": "#D7434C",
      "color-on-tab": "#ffffff"
    }
  },
  {
    "name": "noite-estrelada",
    "colors": {
      "color-system": "#ffffff",
      "color-background": "#212121",
      "color-background-center": "#424242",
      "color-text": "#FFFFFF",
  
      "color-primary": "#3f51b5",
      "color-on-primary": "#FFFFFF",
      "color-primary-light": "#7986cb",
      "color-primary-container": "#9fa8da",
  
      "color-secondary": "#fdd835",
      "color-on-secondary": "#212121",
      "color-hint": "#ffeb3b",
      "color-highlight": "#ffee58",
      "color-secondary-container": "#fff9c4",
  
      "color-bg": "#424242",
      "color-on-bg": "#fdd835",
      "color-canvas": "#303f9f",
      "color-divider": "#303f9f",
  
      "color-surface": "#303030",
      "color-on-surface": "#FFFFFF",
      "color-box-shadown": "#303f9f",
  
      "color-shimmer": "#757575",
      "color-shimmer-light": "#9e9e9e",
      "color-progress": "#fbc02d",
      "color-selection": "#fbc02d",
  
      "color-tab": "#3f51b5",
      "color-tab-shadown": "#1a237e",
      "color-tab-primary": "#FFFFFF",
      "color-on-tab": "#7986cb"
    }
  },
  {
    name: "steel",
    colors: {
      "color-system": "#f5f5f5",
      "color-background": "#1a1e2b",
      "color-background-center": "#2d3447",
      "color-text": "#ffffff",
  
      "color-primary": "#252a3a",
      "color-on-primary": "#ffffff",
      "color-primary-light": "#a1a8c1",
      "color-primary-container": "#d18e4d",
  
      "color-secondary": "#d18e4d",
      "color-on-secondary": "#252a3a",
      "color-hint": "#bfc5e2",
      "color-highlight": "#c7b294",
      "color-secondary-container": "#a19e89",
  
      "color-bg": "#4a5568",
      "color-on-bg": "#d18e4d",
      "color-canvas": "#2d3a48",
      "color-divider": "#3d4a66",
  
      "color-surface": "#344056",
      "color-on-surface": "#ffffff",
      "color-box-shadown": "#1a2236",
  
      "color-shimmer": "#3d4a5d",
      "color-shimmer-light": "#d1ddef",
      "color-progress": "#4dc3d1",
      "color-selection": "#5d7b90",
  
      "color-tab": "#d18e4d",
      "color-tab-shadown": "#5d4a37",
      "color-tab-primary": "#252a3a",
      "color-on-tab": "#7c4a1a"
    }
  },
    {
      name: "dark-forest",
      colors: {
        "color-system": "#ffffff",
        "color-background": "#2c3e50",
        "color-background-center": "#34495e",
        "color-text": "#ffffff",
    
        "color-primary": "#1abc9c",
        "color-on-primary": "#ffffff",
        "color-primary-light": "#48c9b0",
        "color-primary-container": "#16a085",
    
        "color-secondary": "#f39c12",
        "color-on-secondary": "#2c3e50",
        "color-hint": "#f1c40f",
        "color-highlight": "#e67e22",
        "color-secondary-container": "#e74c3c",
    
        "color-bg": "#16a085",
        "color-on-bg": "#2c3e50",
        "color-canvas": "#27ae60",
        "color-divider": "#2980b9",
    
        "color-surface": "#1abc9c",
        "color-on-surface": "#ffffff",
        "color-box-shadown": "#2c3e50",
    
        "color-shimmer": "#1abc9c",
        "color-shimmer-light": "#a2d9ce",
        "color-progress": "#f80000",
        "color-selection": "#8e44ad",
    
        "color-tab": "#f39c12",
        "color-tab-shadown": "#d35400",
        "color-tab-primary": "#1abc9c",
        "color-on-tab": "#d35400"
      }
    },
    
  ];